//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { Check, ChevronLeftOutlined, ChevronRightOutlined, Close, KeyboardArrowDownOutlined, Download } from '@mui/icons-material';
import { Button, Input, TextField } from '@mui/material';
//  -- Components ---------------------
import { Dropdown, Row, Tooltip } from 'antd';
import Loading from 'components/Loading';
import moment from 'moment';
import { lighten } from 'polished';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
//  -- Thunks -------------------------
import { handleListSubmissionsByAssignmentAndClass, handleUpdateGrade, handleUpdateSubmission, handleAiAutoGradingSchedule} from 'store/submissions/thunks';
import styled from 'styled-components';
//  -- Constants ----------------------
import { ArrowDownward, ArrowRight, ArrowUpward } from '@mui/icons-material';
import AssignmentRecorder from "features/AssignmentReviewRecoder";
import { useNavigate } from "react-router-dom";
import COLOR from 'utils/constants/color';
//  -- Lib ----------------------------
import { concat, filter, find, findIndex, get, has, map, cloneDeep } from 'lodash';
import { getBookDisplayName, getConfigForDiff, imageFetch, imageFetchFromPodcast, isVideo } from 'utils/lib/ebookHelper';

import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    styled as muiStyled,
    Switch,
    Typography
} from '@mui/material';

import { EyeOutlined, LeftOutlined } from '@ant-design/icons';
import * as Sentry from '@sentry/react';
import GradeDisplay from 'components/GradeDisplay';
import { useOrientation } from 'components/hooks';
import { useAssignmentCoverTitle } from 'components/hooks/pageCover/useAssignmentCoverTitle';
import usecheckIFrame from 'components/hooks/usecheckIFrame';
import SpinLoader from 'components/Loader/SpinLoader';
import { AlertSakeBar } from 'components/UI';
import { useTabletDetection } from 'containers/chat/hooks';
// import { useFirebase } from 'containers/FirebaseContext';
import AssignmentImgModal from 'features/AssignmentImgModal';
import StudentAssignmentTrackingModal from 'components/StudentAssignmentTracking/StudentAssignmentTrackingModal';
import { getSubmissionActivityLogId } from 'components/StudentAssignmentTracking/studentAssignmentTrackingStatic';
import { buildTrackingLogSources } from 'components/StudentAssignmentTracking/studentAssignmentTrackingUtils';
import SplitPane from 'split-pane-react';
import 'split-pane-react/esm/themes/default.css';
import { handleUpdateCanvasGradeInBatch } from 'store/canvas/thunks';
import { useSocket } from 'store/chat/selectors';
import { useClassActivities } from 'store/classActivities/selectors';
import { useClassQuizzes } from 'store/classQuizzes/selectors';
import { handleUpdateGoolgeGradeInBatch } from "store/googleClassRoom/thunks";
import { useClassGameActivity } from 'store/one_game/selectors';
import { useResources, useVideos } from 'store/resources/selectors';
import { useRubrices } from 'store/rubric/selectors';
import { handleGradeToSchoology } from 'store/schoology/thunks';
import { useClassSubmissions } from 'store/submissions/selectors';
import { useClassUsers } from 'store/userClasses/selectors';
import { useCurrentUser, useUserProfileConfig } from 'store/users/selectors';
import { handleListQuestionOfWorksheet } from 'store/worksheet/thunks';
import { MenuIcon } from "utils/assets/images";
import SentryWrap from 'components/Sentry';
import { useCollectionNotification } from 'utils/methods/firebaseNotification';
import { af_grade, checkHasAutoGrade, checkIsManualGradable, checkIsTbgTxt, getDiffConfigForStudent, isBeforTime, isGradedByTeacher } from 'utils/methods/math';
import { useGradeBook } from 'components/hooks/gradeBook/useGradeBook';
import { v4 } from 'uuid';
import assignmentImage from "../../utils/assets/images/assignment-image.png";
import openSubMissionImage from "../../utils/assets/images/open-submission-image.png";
import AssignmentDeviceModal from './AssignmentDeviceModal';
import GradebookRubrics from "./GradebookRubric";
import { getCoverForAssignment } from 'utils/methods/functions';
import { usePageCover } from 'components/hooks/pageCover/pageCover';
import AiGradeAllButton from './AiGradeAllButton';
import AssignmentPrintView from './AssignmentPrintView';
import { generateAssignmentPDF } from 'utils/methods/generateAssignmentPDF';
import {
    resolveAiGradingLevel,
    resolveOverallGradeForPrint,
} from 'utils/methods/assignmentPrintHeaderHelpers';
import { mergeSubmissionUpdate } from 'utils/mergeSubmissionUpdate';

//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------

// MUI styled components
const StyledAccordion = muiStyled(Accordion)(({ theme }) => ({
  border: '1px solid white',
  boxShadow: 'none',
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&:before': {
    display: 'none',
  },
  '&.Mui-expanded': {
    margin: 'auto',
  },
}));

const StyledAccordionSummary = muiStyled(AccordionSummary)(({ theme }) => ({
  backgroundColor: '#03989e',
  color: 'white',
  textTransform: 'capitalize',
  borderBottom: '1px solid white',
  marginBottom: -1,
  minHeight: 30,
  '&.Mui-expanded': {
    minHeight: 30,
  },
  '& .MuiAccordionSummary-content': {
    '&.Mui-expanded': {
      margin: '8px 0',
    },
  },
}));

const StyledAccordionDetails = muiStyled(AccordionDetails)(({ theme }) => ({
  padding: '2px',
  margin: 0,
}));


// Keep existing styled-components
const ImageStoryTitle = styled.div`
    position: absolute;
    top: 54.5%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #fff;
    text-align: center;
    font-weight: bold;
    font-size: ${(props) => props?.fontSize ? props?.fontSize : "32px"};
    z-index: 1;
`;

const Description = styled.span`
    color: ${COLOR.black300};
    display: block;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    margin-bottom: 48px;
`;
const UserAddignmentLabel = styled.span`
    font-size: 12px;
    font-weight: 400;
    line-height: 13px;
    background: #e7edf2;
    padding: 10px;
    display: flex;
    align-items: center;

    @media screen and (max-width:768px){
        height: auto;
    }
`;
const HeaderWrapper =  styled.div`
  display:flex;
  flex-direction:row;
  align-items:center;
  flex-wrap: wrap;
  gap: 10px;
`;
const HeaderDownloadButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  font-size: 12px;
  font-weight: 600;
  color: white;
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 4px;
  cursor: pointer;
  margin-right: 8px;
  transition: all 0.2s;
  &:hover {
    background: rgba(255, 255, 255, 0.3);
    border-color: rgba(255, 255, 255, 0.5);
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
const UserSelector = styled(UserAddignmentLabel)`
    font-weight: 400;
    line-height: 18px;
    height: 30px;
    background:${p =>p.$user_not_active?"red": p.active ? 'rgb(14 70 183 / 87%)' : '#e7edf2'};
    color:${p => p.active || p.$user_not_active ? '#e7edf2' : COLOR.black100};
    box-shadow:  ${p => p.active ? "0px 0px 0px 0px #958585e0, 0px 0px 5px 0px #958585e0" : "0px 0px #fff"};
    padding: 10px 10px 15px;
    display: flex;
    align-items: center;
    margin: 10px;
    cursor: pointer;
    font-size: 12px;
    display: flex;
    justify-content: space-between;
    overflow-x: hidden;
    overflow-y: hidden;
    display: flex;
    height: 30px;
    // width: 100%;
`;

const UserSelectorList = styled.div`
    // max-height: 500px;
    // max-height: 327px;
    // overflow-y: scroll;
    margin-bottom:20px !important;
    // overflow-x: hidden;
    // min-height: 150px;
        padding-bottom: 1px;

    // @media screen and (max-width: 1100px) {
    //     max-height: calc(100dvh - ${p=> p.checkFrame ? "387px" : "412px"}) !important;
    //     // max-height: calc(100dvh - ${p=> p.checkFrame ? "387px" : "452px"});
    // }

    // @media screen and (max-width: 768px){
    //     max-height: calc(100vh - ${p=> p.checkFrame ? "387px" : "409px"});
    // }
`;

const Header = styled(Description)`
    color: ${COLOR.black100};
    font-size: 17px; 
    font-weight: 900;
    line-height: 28px;
    margin-bottom: 16px;
    position: absolute;
    top: 13px;
    left: 56px;
    display: flex;
    align-items: center;
    gap: 16px;
`;

const Image = styled.img`
    // border: 1px solid ${COLOR.black800};
    // width: 100%;
    // height: auto;
    width:69px;
    height:84px;
    
`;

const ImageContiner = styled.div`
    background-color: transparent;
    border: none;
    flex: 1;
    outline: none;
    width: 100%;
`;


const Notification = styled.div`
    background-color: ${p => p.bgColor ? p.bgColor : lighten(0.45, '#3D5F8F')};
    border: 1px dashed ${p => p.bgColor ? p.color : '#3D5F8F'};
    border-radius: 3px;
    color: ${p => p.color ? p.color : '#3D5F8F'};
    font-size: 12px;
    font-weight: 600;
    margin-bottom: 24px;
    padding: 8px;
`;


const Wrapper = styled.div`
    margin: 0px auto; 
    max-width: 100%;
    padding: 0px;
    width: 100%;
`;

const Rotate = styled.div`
    align-items: center;
    display: flex;
    height: 16px;
    justify-content: center;
    margin-right: 4px;
    transform: ${p => p.open ? 'rotate(90deg)' : 'rotate(0deg)'};
    transition: all 300ms ease;
    width: 16px;
`;
const AccordianTitle = muiStyled(Typography)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
}));
const SortingButton = styled.button`
    font-size: 12px;
    border: 1px solid #c3c1c1;
    padding: 2px;
    border-radius: 5px;
    padding-left: 4px;
    padding-right: 4px;
    color: ${p => p.active ? '#3f53b7' : COLOR.black100};
    cursor: pointer;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    min-width: 90px;
    margin: 0px 2px;

    @media screen and (max-width: 768px){
       min-width: unset;
    }
`;
const NameText = styled.span`
    margin-right: 6px;
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-right:5px;
`;

const CategoryMenu = styled.div`
    background-color:${COLOR.tabActive};
    border-radius: 13px;
    color: #fff;
    height: 30px;
    padding-left: 20px;
    padding-right: 2px;
    margin-top: 4px;
    font-size: 13px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width:70%;
    align-items: center;
    cursor: pointer;

`;
const PaddedBtn = styled.button`
    background-color: transparent;
    border: none;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    outline: none;
    padding: 8px;
    text-align: left;
    width: 100%;
`;
const MenuIconImg = styled.img`
    margin-left:10px;
    height: 16px;
    background-color: #fff;
    border-radius: 50%;
    padding: 2px;
    margin-right: 10px;
`;

const MaxPointText = styled.span`
color:${COLOR.gray100}
`;
const PreviewArea = styled.div`
//    max-height:60vh;
//    max-height:100vh;
   overflow: auto;
//    min-height: 250px;
  ::-webkit-scrollbar {
    width: 10px; /* Width of the scrollbar */
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background: #888; 
    border-radius: 5px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #555; 
  }


//     @media screen and (max-width: 1100px){
//      max-height: calc(100dvh - 528px);
//         // max-height: calc(100dvh - 412px);
//         // min-height: 300px;
//      max-height: calc(100dvh - 404px);
//   }

//     @media screen and (max-width: 768px){
//         max-height: calc(100dvh - 365px);
//     }
`;

const SubmissionMessage = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    font-size: 29px;
    font-weight: 600;
    text-align: center;
    color: #35383d;
`
const SubmissionMessages = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    height: 0px;
    font-size: 29px;
    font-weight: 600;
    text-align: center;
    color: #35383d;
`
const AssignmentImg = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 26px;
    font-size: 20px;
    margin: 0 auto;
`;

const BackText = styled.div`
   color: ${COLOR.black100};
    font-size: 15px; 
    font-weight: 600;
    line-height: 28px;
    cursor:pointer;
    display: flex;
    align-items: center;
`;

const RotatingArrow = styled.span`
  transition: transform 0.3s ease;
  transform: ${props => props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
  display: inline-flex;
  align-items: center;
`;

const GradeEditorInput = muiStyled(Input)({
    border: 'none',
    fontSize: '12px',
    width: '70px',
    background: 'white',
    textAlign: 'center',
    outline: 'none',
    '& input': {
        textAlign: 'center',
    }
});


const CurrentSubmission = {
    backgroundColor: '#9933ff'
}

const sortname = (a, b, key, orderBy = "ASC") => {
    try {
        const nameA = get(a, key, "").toLowerCase()?.replace(/\s/g, '');
        const nameB = get(b, key, "").toLowerCase()?.replace(/\s/g, '');
        if (orderBy === "ASC") {
            if (nameA < nameB) { return -1 }
            else if (nameA > nameB) { return 1 }
            else { return 0 }
        } else {
            if (nameA > nameB) { return -1 }
            else if (nameA < nameB) { return 1 }
            else { return 0 }
        }
    } catch (error) {
        Sentry.captureException(`577 Error in sortname: ${error}`);
        return 0;
    }
}

const putSelectedUserAtTop = (userList, selectedUserId) => {
    if (!selectedUserId || !userList || userList.length === 0) {
        return userList;
    }
    const selectedUserIndex = userList.findIndex(item => get(item, "user.id") === selectedUserId);
    if (selectedUserIndex === -1 || selectedUserIndex === 0) {
        return userList;
    }
    const selectedUser = userList[selectedUserIndex];
    const restOfUsers = [...userList.slice(0, selectedUserIndex), ...userList.slice(selectedUserIndex + 1)];
    return [selectedUser, ...restOfUsers];
}
const hasGradeInA_F = (val) => {
    if (typeof val === "string") {
        const hasInGrade = [{ key: 'A', value: 90 }, { key: 'B', value: 70 }, { key: 'C', value: 50 }, { key: 'D', value: 30 }, { key: 'F', value: 10 }].find(k => k.key.toLowerCase() === val.toLowerCase())
        if (hasInGrade) {
            return ({
                value: hasInGrade.value,
                hasValue: true
            })
        }
        return ({
            value: val,
            hasValue: false
        })
    } else {
        return ({
            value: val,
            hasValue: false
        })
    }

}
const isGraphicOrganizer = (submission, fallback) => {
    const check = (val) => val === "graphic_organizer";
    return check(get(submission, "assignment.activity_type")) ||
           check(get(fallback, "data.activity_type")) ||
           check(get(fallback, "activity_type"));
};
const isGraphicOrgInProgress = (submission, fallback) => {
    const answers = get(submission, "answers", []);
    const hasAnswers = Array.isArray(answers) ? answers.some((a) => a != null) : false;
    return isGraphicOrganizer(submission, fallback) &&
        !get(submission, "complete") &&
        get(submission, "retaking") &&
        hasAnswers;
};
const AssignmentReview = ({
    data = {},
    booksAllList = [],
    handleClose = () => {},
    scale_1_5 = false,
    gradebook_a_f = false,
    currentClass = {},
    usersSubmissionData = [],
    ap_scale = false,
    open = false,
    returnedSubmissionIds,
    onReturnSuccess,
    showAlert = () => {},
}) => {
    const checkFrame = usecheckIFrame();
    const tabletType = useTabletDetection();
    const { socketConnection, reCreateSocket } = useSocket()
    const dispatch = useDispatch();
  	const navigate = useNavigate();
    const currentUser = useCurrentUser();
    const isTeacher = currentUser?.role === 'teacher';
    const isSubmissionEditBlocked = useCallback(
        (submission) => currentUser?.role !== 'teacher' || Boolean(get(submission, 'disableEdit')),
        [currentUser?.role],
    );
    // const { firestore } = useFirebase();
    const [grade_value, setGrade] = useState('');
    const [feedback, setFeedback] = useState('');
    const [audioFeedback, setAudioFeedback] = useState(null);
    const [loading, setLoading] = useState(null);
    const [updateLoading, setUpdateLoading] = useState(null);
    const resources = useResources();
    const videos = useVideos();
    const [pastSubmissions, setPastSubmissions] = useState([])
    const [expanded, setExpanded] = React.useState(null);
    const [selectedUser, setSelectedUser] = useState()
    const [selectedUserChange, setSelectedUserChange] = useState()
    const [submissionData, setSubmissionData] = useState()
    const canEditSubmission = useMemo(
        () => isTeacher && !get(submissionData, 'disableEdit'),
        [isTeacher, submissionData?.disableEdit],
    );
    const [allUserSubmissions, setAllUserSubmissions] = useState([])
    const [allFilteredUser, setAllFilteredUser] = useState([])
    const [sortBy, setSortBy] = useState({ fname: null, lname: null, status: null })
    const { class_game_activity } = useClassGameActivity()
    const classActivities = useClassActivities();
    const classQuizzes = useClassQuizzes()
    const { isAiPermissionEnabled } = useUserProfileConfig();
    const combinedAssignments = useMemo(
        () => concat(classActivities || [], classQuizzes || [], class_game_activity || []),
        [classActivities, classQuizzes, class_game_activity]
    );
    const assignment = useMemo(() => {
        const assignmentId = data?.assignmentId;
        if (!assignmentId) return null;
        return combinedAssignments.find(k => k.quizId === assignmentId || k.activityId === assignmentId || k.seesion_id === assignmentId);
    }, [combinedAssignments, data?.assignmentId])
    const [assignmentshow, setAssignmentshow] = useState(false);
    const is_feedback_input_active = useRef(false);
    const { submissionStatus, inProgressStatus } = useMemo(() => {
    try{
        const complete = get(submissionData, "complete");
        const sub_answers = get(submissionData, "answers",[]);
        const answersLength = get(sub_answers, "length",0);
        const questionsLength = get(assignment, "questions.length", 0);
        const submissions = get(submissionData, "submissions");
        const retaking = get(submissionData, "retaking");
        const assignmentType = get(submissionData, "assignmentType", get(submissionData, "type"));
        const isWorksheet = assignmentType === "worksheet";
        const graphicOrgInProgress = isGraphicOrgInProgress(submissionData, assignment);
        const hasAnswers = Array.isArray(sub_answers)
            ? answersLength > 0
            : Object.keys(sub_answers || {}).length > 0;
        const submissionStatus = (submissions == 0 && answersLength == 0) && !(submissionData?.graded && !submissionData?.isTemp) && !graphicOrgInProgress;
        const inProgressStatus = !complete && (
            graphicOrgInProgress ||
            (isWorksheet && get(submissionData, "id") ? true : false) ||
            (hasAnswers && (!questionsLength || questionsLength >= answersLength))
        );
            return {
                submissionStatus,
                inProgressStatus,
            };
    }catch(error){
        Sentry.captureException(`578 Error in timmerStatus: ${error}`);
        console.log(error);
        return {
            submissionStatus:false,
            inProgressStatus:false,
        };
    }
    }, [submissionData,assignment]);

    const [select, setSelect] = useState("All")
    const feedbackAudioRef = useRef()
    const [rubricScore, setRubricScore] = useState()
    const pdfContentRef = useRef();
    const [pdfData, setPdfData] = useState({
        pdfQuestions: [],
        pdfAnswers: [],
        pdfStudentName: '',
        pdfClassName: '',
        pdfActivityTitle: '',
        pdfAiGrades: [],
        pdfAiFeedbacks: [],
        pdfAiSuggestions: [],
        pdfOverallGrade: '',
        pdfProficiencyLevel: '',
    });
    const [generatingPDFForId, setGeneratingPDFForId] = useState(null);
    const inputRef = useRef()
    const classUsers = useClassUsers()
    const {createCollectionNotification} = useCollectionNotification();
    const inputsRefs = useRef([])
    const rubrics = useRubrices()
        const assignmentRubrics = useMemo(() => {
            const diffConf = getDiffConfigForStudent(selectedUser?.id, assignment, currentClass.id)
            const diff_rubrics = diffConf ? diffConf.rubrics_id : null 
        const rubrics_id = diff_rubrics || assignment?.rubrics_id;
        return rubrics_id ? find(rubrics, ['id', rubrics_id]) : null
    }, [rubrics, assignment, selectedUser, currentClass])
    const isUngraded = useMemo(() => Boolean(get(assignment, "ungraded")), [assignment]);
    const grade_type = assignment?.grade_type;
    const max_point = assignment?.max_point && !isNaN(assignment?.max_point) ? Number.parseInt(assignment.max_point, 10) : 100
    const isCompleteInComplete = grade_type === "complete_incomplete"
    const isPointSystem = grade_type === "points"
    const assignment_grade = useMemo(()=>getAssignmentGradeValue(submissionData, assignment),[submissionData, assignment])
    const current_assignment_returned  = useMemo(()=>isReturned(isUngraded,submissionData),[submissionData,isUngraded])
    const selected_assignment_tbg = checkIsTbgTxt(assignment_grade)
    const is_graphic_organizer_assignment = isGraphicOrganizer(submissionData, assignment)
    const currentSubmissionRubric = get(submissionData, "rubrics_data", []);
    const ai_grade_feedback = get(submissionData, "ai_grade", []);
    const pastSubmissionRubric = get(pastSubmissions, "rubrics_data", []);
    const [modalOpen, setModalOpen] = useState(false);
    const [trackingLogId, setTrackingLogId] = useState(null);
    const [trackingSubmissionLabel, setTrackingSubmissionLabel] = useState('');
    const closeStudentTrackingModal = useCallback(() => {
        setTrackingLogId(null);
        setTrackingSubmissionLabel('');
    }, []);
    const trackingLogSources = useMemo(
        () => buildTrackingLogSources(pastSubmissions, submissionData),
        [pastSubmissions, submissionData]
    );
    const [is_mobile_menu,setMobileMenu] = useState(false);
    const orientation = useOrientation();
    const [isOpen, setIsOpen] = useState(false);
    const allSubmission  =  useClassSubmissions()
    const [questions,setQuestions] = useState([])
    const [loadingQuestions,setloadingQuestions] = useState(false)
    const [refreshLoading, setRefreshLoading] = useState(false)
    const { isDoneLateSubmission, getSubmissionStatus, getMarkStatus, getMarkStatusBingo, getGradeWithPreference, hasValidAiFeedback  } = useGradeBook();
    const assignedStudentList = useMemo(() => {
        const currentClassData = assignment?.classes?.find((cls) => cls.id === currentClass?.id);
        if(currentClassData && Object.keys(currentClassData).length > 0){
          const currentClassUsers = currentClassData?.users || [];
          if(currentClassUsers?.length > 0){
            const checkCurrentUserAssigned = currentClassUsers.includes(selectedUser?.id);
            return checkCurrentUserAssigned
          }else{
            return true;
          }
        }else{
          return true;
        }
      }, [selectedUser,currentClass,assignment])

    const hasGradeForFeedback = useMemo(() => {
      if (!submissionData?.id || !assignedStudentList) return false;
      if (isUngraded) return true;
      const hasRubric =
        (typeof rubricScore === "number" && rubricScore >= 0) ||
        (typeof rubricScore === "string" && rubricScore.length > 0);
      const g = grade_value;
      const hasGrade =
        (typeof g === "number" && g >= 0) ||
        (typeof g === "string" &&
          g.length > 0 &&
          g !== "-" &&
          g !== "--");
      return hasRubric || hasGrade;
    }, [
      submissionData?.id,
      assignedStudentList,
      isUngraded,
      grade_value,
      rubricScore,
    ]);

    const [alertSakeBar, setAlertSakeBar] = useState({
        open: false,
        message: "",
        severity: "success",
    });
    const handleDropdownVisibleChange = (visible) => {
        setIsOpen(visible);
    };
    useEffect(() => {
        try {
            if (!open || !allSubmission?.length) return;
            
            requestAnimationFrame(() => {
                const submissionMap = new Map(allSubmission.map(sub => [sub.id, sub]));
                
                setAllUserSubmissions(prevData => {
                    if (Array.isArray(prevData)) {
                        return prevData.map(v => {
                            if (v.id && submissionMap.has(v.id)) {
                                return mergeSubmissionUpdate(v, submissionMap.get(v.id));
                            }
                            return v;
                        });
                    }
                    return prevData
                });
                
                setSubmissionData(prevData => {
                    if (prevData?.id && allSubmission?.length) {
                        const sub_data = allSubmission.find(v => v && v.id === prevData.id) || {};
                        return mergeSubmissionUpdate(prevData, sub_data);
                    }
                    return prevData
                });
            });
        } catch (error) {
            Sentry.captureException(`579 Error in seting state: ${error}`);
            console.log("error in seting state",error.message)
        }
       
    }, [allSubmission, open]);
    useEffect(() => {
        const onResize = () => {
            if (window.innerWidth >= 1100) {
                setMobileMenu(false)
            } else if (window.innerWidth < 1100) {
                setMobileMenu(true)
            }
        };
        onResize();
        window.addEventListener('resize', onResize);

        return () => {
            window.removeEventListener('resize', onResize);
        };
    }, [orientation]);

    // useEffect(() => {
    //     const unsubscribe = listenToAutoSubmission();
    //     return () => {
    //         unsubscribe();
    //     };
    // }, [firestore, data, usersSubmissionData, selectedUserChange])

    // const listenToAutoSubmission = () => {
    //     const submissionDocId = data?.assignmentId + selectedUserChange?.id;
    //     const collectionRef = collection(firestore, "auto_submission");
    //     const q = query(collectionRef,
    //         where("submissionId", "==", submissionDocId),
    //     );
    //     const unsubscribe = onSnapshot(q, (querySnapshot) => {
    //         querySnapshot.forEach(async (doc) => {
    //             const autoSubmission = doc.data();
    //             const docId = doc?.id;
    //             const autoReceiveData = autoSubmission?.submissionData || {};
    //             let newUserSubmission = []
    //             if (usersSubmissionData?.length > 0) {
    //                 newUserSubmission = usersSubmissionData.map(submission =>
    //                     submission?.id === autoReceiveData?.id ? { ...submission, ...autoReceiveData } : submission
    //                 );
    //             } else {
    //                 newUserSubmission = [...usersSubmissionData, autoReceiveData];
    //             }
    //             if (data?.complete && (parseInt(data?.submissions) === parseInt(autoReceiveData?.submissions))) {
    //                 return;
    //             }
    //             autoReceiveData.user.isPreview = selectedUser?.isPreview ? true : false;
    //             autoReceiveData.user.isShowRubric = selectedUser?.isShowRubric ? true : false;
    //             setSelectedUser(get(autoReceiveData, "user"))
    //             setSubmissionData(autoReceiveData)
    //             setAllUserSubmissions(newUserSubmission)
    //             await dispatch(realTimeSubmissionSuccess(autoReceiveData));
    //             if (autoSubmission?.status) {
    //                 deleteSubmissionData(docId)
    //                 return;
    //             }
    //         });
    //     }, (error) => {
    //         console.error("Error listening to session changes:", error);
    //     });

    //     return unsubscribe;
    // }

    const getResolvedStudentUser = useCallback((userData = {}, userId) => {
        const resolvedId = get(userData, "id") || userId;
        const classUser = find(classUsers, ["id", resolvedId]) || {};
        const firstName = (get(userData, "firstName", "") || get(classUser, "firstName", "")).trim();
        const lastName = (get(userData, "lastName", "") || get(classUser, "lastName", "")).trim();
        return {
            ...classUser,
            ...userData,
            id: resolvedId,
            firstName,
            lastName,
        };
    }, [classUsers]);

    const enrichSubmissionWithAssignment = useCallback((submission) => {
        if (!submission) return submission;
        const resolvedUser = getResolvedStudentUser(get(submission, "user", {}), get(submission, "userId"));
        
        const hasGrade = submission.grade !== undefined && submission.grade !== null && 
                       (typeof submission.grade === 'number' || 
                        (typeof submission.grade === 'string' && submission.grade !== '0' && submission.grade !== ''));
        const hasComplete = submission.complete === true;
        const assignmentExists = submission.assignment && Object.keys(submission.assignment).length > 0;
        const assignmentMissingFields = assignmentExists && 
            (!submission.assignment.bookId || 
             !submission.assignment.language_feedback || 
             !submission.assignment.type);
        
        if ((hasGrade || hasComplete) && (assignmentMissingFields || !assignmentExists)) {
            const fullAssignment = combinedAssignments
                .find(k => k.quizId === submission.assignmentId || 
                          k.activityId === submission.assignmentId || 
                          k.seesion_id === submission.assignmentId);
            
            if (fullAssignment) {
                const assignmentData = fullAssignment.data || fullAssignment.assignment || fullAssignment;
                const existingAssignment = submission.assignment || {};
                
                return {
                    ...submission,
                    user: resolvedUser,
                    assignment: {
                        ...assignmentData,
                        ...existingAssignment,
                        id: existingAssignment.id || submission.assignmentId,
                        questions: existingAssignment.questions || assignmentData?.questions || [],
                        chapter: existingAssignment.chapter || assignmentData?.chapter || submission.chapter,
                        displayName: existingAssignment.displayName || assignmentData?.displayName,
                        page: existingAssignment.page || assignmentData?.page,
                        typeId: existingAssignment.typeId || assignmentData?.typeId || submission.assignmentType
                    }
                };
            }
        }
        return {
            ...submission,
            user: resolvedUser,
        };
    }, [combinedAssignments, getResolvedStudentUser]);

    useEffect(() => {
        if (!selectedUser) {
            const resolvedDataUser = getResolvedStudentUser(get(data, "user", {}), get(data, "userId"));
            setSelectedUser(resolvedDataUser)
            setUpdateLoading(null);
            setSelectedUserChange(resolvedDataUser)
        }
        const enrichedData = enrichSubmissionWithAssignment(data);
        setSubmissionData((prev) => {
            if (prev?.id && enrichedData?.id === prev.id) {
                return mergeSubmissionUpdate(prev, enrichedData);
            }
            return enrichedData;
        });
    }, [data, enrichSubmissionWithAssignment, getResolvedStudentUser])
    
    useEffect(() => {
        if (!usersSubmissionData || !Array.isArray(usersSubmissionData)) {
            setAllUserSubmissions([]);
            setAllFilteredUser([]);
            return;
        }
        if (!open) return;

        requestAnimationFrame(() => {
            const enrichedSubmissions = usersSubmissionData.map(submission => enrichSubmissionWithAssignment(submission));
            const selectedUserId = get(selectedUser, "id") || get(data, "user.id");
            const sortedSubmissions = putSelectedUserAtTop(enrichedSubmissions, selectedUserId);
            
            requestAnimationFrame(() => {
                setAllUserSubmissions(sortedSubmissions);
                setAllFilteredUser(sortedSubmissions);
            });
        });
    }, [usersSubmissionData, enrichSubmissionWithAssignment, open])

      const fetchData = async (id) => {
        try {
            setloadingQuestions(true);
            const response = await dispatch(handleListQuestionOfWorksheet(id));
            if(Array.isArray(response)&&response.length>0){
                setQuestions(response);
            }else{
                setQuestions([]);
                showAlert("No questions found for this worksheet.", "warning")
            }
            
        } catch (error) {
            
        } finally{
            setloadingQuestions(false)
        }
       
      };
    useEffect(()=>{
        if (!open) return;
        if(Array.isArray(usersSubmissionData)){
            const dt = usersSubmissionData[0];
            if (dt && dt.assignmentId && dt.assignmentType == "worksheet") {
                fetchData(dt.assignmentId)
            }
        }
    },[usersSubmissionData, open])
    function setDefaultValue() {
        const { grade, face_grade } = getGradeval(submissionData);
        const typeId = get(submissionData, "assignment.typeId", "");
        const assignmentType = get(submissionData, "assignmentType", "");
        const is_game = typeId == "game";
        const is_debate = assignmentType == "debate";
        const is_worksheet = assignmentType == "worksheet";
        const is_loteria = assignmentType == "bingo";

        const isCompleteTbg = checkIsManualGradable(get(submissionData, "assignment.questions", []));
        const is_ai_graded = submissionData?.ai_grade?.length > 0;

        let expected_grade = isPointSystem ? face_grade : grade;
        const isValidGrade =
            expected_grade == 0 || expected_grade > 0 || (typeof expected_grade == "string" && expected_grade.length > 0);

        expected_grade = isValidGrade ? expected_grade : "";

        const needsManualGrading =
            !is_ai_graded &&
            isCompleteTbg &&
            !is_game &&
            !is_debate &&
            !is_loteria &&
            !is_worksheet &&
            !expected_grade &&
            submissionData?.manualGrading &&
            submissionData?.waiting_for_ai_grade;

        const finalGrade = !submissionData?.id || needsManualGrading ? "" : expected_grade;
        setGrade(finalGrade);
    }
    useEffect(() => {
        requestAnimationFrame(() => {
            setPastSubmissions(getpastSubmissions(submissionData))
            setDefaultValue()
            setFeedback(submissionData?.feedback || '');
            setAudioFeedback(submissionData?.audioFeedback || null);
            if (feedbackAudioRef.current) {
                feedbackAudioRef.current.reset()
                feedbackAudioRef.current.setAudio(submissionData?.audioFeedback)
            }
            setExpanded(get(submissionData, 'id'));
        });
    }, [submissionData, combinedAssignments])
    
    useEffect(() => {
        if (!submissionData) return;
        
        const hasGrade = submissionData.grade !== undefined && submissionData.grade !== null && 
                       (typeof submissionData.grade === 'number' || 
                        (typeof submissionData.grade === 'string' && submissionData.grade !== '0' && submissionData.grade !== ''));
        const hasComplete = submissionData.complete === true;
        const assignmentExists = submissionData.assignment && Object.keys(submissionData.assignment).length > 0;
        const assignmentMissingFields = assignmentExists && 
            (!submissionData.assignment.bookId || 
             !submissionData.assignment.language_feedback || 
             !submissionData.assignment.type);
        
        const needsEnrichment = (hasGrade || hasComplete) && (assignmentMissingFields || !assignmentExists);
        
        if (needsEnrichment && combinedAssignments.length > 0) {
            requestAnimationFrame(() => {
                const enrichedData = enrichSubmissionWithAssignment(submissionData);
                const assignmentChanged = enrichedData.assignment?.bookId !== submissionData.assignment?.bookId ||
                                         enrichedData.assignment?.language_feedback !== submissionData.assignment?.language_feedback ||
                                         enrichedData.assignment?.type !== submissionData.assignment?.type;
                
                if (assignmentChanged) {
                    requestAnimationFrame(() => {
                        setSubmissionData(enrichedData);
                    });
                }
            });
        }
    }, [submissionData, combinedAssignments, enrichSubmissionWithAssignment])
    
    const setData = useCallback((dt) => {
        requestAnimationFrame(() => {
            const enrichedData = enrichSubmissionWithAssignment(dt);
            const user = getResolvedStudentUser(get(enrichedData, "user", {}), get(enrichedData, "userId"));
            requestAnimationFrame(() => {
                setSelectedUser(prev => ({...user, isPreview: prev?.isPreview, isShowRubric: prev?.isShowRubric}));
                setSubmissionData(enrichedData);
                setSelectedUserChange(prev => ({...user, isPreview: prev?.isPreview, isShowRubric: prev?.isShowRubric}));
            });
        });
    }, [enrichSubmissionWithAssignment, getResolvedStudentUser])
    const isDueDatePassed = (user) => {
        if (!assignment) return false;
        const classConfig = find(assignment.classes, ['id', currentClass?.id]);
        const diffConfig =  getConfigForDiff(classConfig,user?.id)
        if (diffConfig.dueDateDif) {
            return isBeforTime(diffConfig.dueDateDif);
        } else {
            return assignment.lateDate ? isBeforTime(assignment.lateDate) : isBeforTime(assignment.dueDate);
        }
    };
    function getGradeval (dt) {
        let grade = get(dt, "grade", '');
        const face_grade = get(dt, "face_grade",'');
        if (scale_1_5) {
            if(grade!=null){
                if (!isNaN(grade)) {
                    grade = Math.min(4, Math.floor((Math.max(0, grade - 1)) / 20)).toString();
                }
            }
        } else if (gradebook_a_f) {
            const isTemp = get(dt, "isTemp");
            const isGraded = get(dt, "graded");
            const manualGrading = get(dt, "manualGrading");
            if ((isGraded && isTemp) || !isGraded) {
                return ({ grade: '-', face_grade });
            }

            if (!isNaN(grade)) {
                grade = af_grade(grade)
            } else {
                grade = "-";
            }
        }
        return ({ grade: trimVal(grade), face_grade:face_grade==null?'-':trimVal(face_grade) });
    }
    const handleChange = (e) => {
        const _value = e.target.value.replace(/-/g, '');
        if(_value === '-') return;
        if (_value.startsWith('0') && _value.length > 1) {
            setGrade('0');
            return;
          }
        if (isPointSystem) {
            if (_value >= 0 && _value <= max_point) {
                setGrade(_value);
            }
        }
        else if (
            (scale_1_5 && _value >= 0 && _value <= 4) ||
            (ap_scale && _value >= 0 && _value <= 5) ||
            (hasGradeInA_F(_value).hasValue && gradebook_a_f) ||
            (!scale_1_5 && !gradebook_a_f && !ap_scale && _value >= 0 && _value <= 100) ||
            _value === ""
        ) {
            setGrade(_value);
        }
    };

    const getpastSubmissions = (dt) => {
        const p_submission = get(dt, "pastSubmissions", []).sort((a, b) => parseInt(a.createdAt) - parseInt(b.createdAt))
        const returnedAtNumbers = (get(dt, "returned_at") || []).map(num => parseInt(num));
        const p_grouped = p_submission.reduce((acc, sub) => {
            const submissionNum = parseInt(sub.submissions);
            if (!acc[submissionNum]) {
                acc[submissionNum] = [];
            }
            acc[submissionNum].push(sub);
            return acc;
        }, {});
        const filtered = Object.values(p_grouped).flatMap((group) => {
            const hasNonEmptyAnswers = group.some(sub => Array.isArray(sub.answers) && sub.answers.length > 0);
            if (hasNonEmptyAnswers && !returnedAtNumbers.includes(parseInt(group[0].submissions))) {
                return group.filter(sub => Array.isArray(sub.answers) && sub.answers.length > 0);
            }
            return group;
        });
        const sorted = filtered.sort((a, b) => parseInt(a.submissions) - parseInt(b.submissions));
        const return_data =  sorted.map((k, i) => {
            let is_return = returnedAtNumbers.includes(parseInt(k.submissions));
            const nextSubmission = sorted[i + 1]
            if (nextSubmission && nextSubmission.submissions === k.submissions) {
                is_return = false;
            }
            return ({ ...k, is_return })
        })
        return return_data
    }
    const handleFeedback = (e) => {
        if (!isTeacher) return;
        setFeedback(e.target.value);
    };
    const handleChangeExpend = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : null);
        if (newExpanded) {
            setAssignmentshow(false);
        }
    };

    const getTBGPoint = (assignVal) => {
        return `${assignVal}/${max_point}`;
    }
    const getHigestMark = (assign, from_past) => {
        if (!assign) {
            return { isHighest: false, val: '', progress: false };
        }
        const assigneGrade = get(assign, "grade", 0);
        const submissionGrade = get(submissionData, "grade", 0);
        const isCurrentAssign = get(assign, "id") === get(submissionData, "id");
        const inProgress =
            (isCurrentAssign && isGraphicOrgInProgress(submissionData, assignment)) ||
            (!get(assign, "complete") && get(assign, "retaking") && get(submissionData, "assignment.questions.length", 0) > get(assign, "assignment.answers.length", 0));

        const assignVal = getAssignmentGradeValue(assign);

        let highest = assigneGrade;

        pastSubmissions.forEach((pt) => {
            const ptGrade = get(pt, "grade", 0);
            const past_grade = getAssignmentGradeValue(pt);
            if (ptGrade > highest &&  !checkIsTbgTxt(past_grade)) {
                highest = ptGrade;
            }
        });

        if (submissionGrade > highest && !inProgress &&   !checkIsTbgTxt(assignVal)) {
            highest = submissionGrade;
        }

        if (highest > assigneGrade || inProgress) {
            return {
                isHighest: false,
                val: isPointSystem ? getTBGPoint(assignVal) : assignVal,
                progress: isCurrentAssign && inProgress,
            };
        } else {
            return {
                isHighest: !checkIsTbgTxt(assignVal) && assignVal !== 0,
                val: isPointSystem ? getTBGPoint(assignVal) : assignVal,
                progress: false,
            };
        }
    };
    const getDisplayName = useCallback((data) => {
        if (data) {
            if (assignment) return assignment.displayName
            return data.displayName || data.assignment?.displayName;
        }
        return ''
    }, [assignment])
    const handleSwitchChange = (event) => {
        setSelectedUser((prev) => {
            const data = { ...prev };
            data.isShowRubric = event.target.checked;
            return data;
        })
        setAssignmentshow(!assignmentshow);
        setIsSwitchChecked(event.target.checked);
    };
    const hasRubricsData = (rubricsData) => {
        if (!rubricsData) return false;

        if (Array.isArray(rubricsData)) return rubricsData.length > 0;
        if (typeof rubricsData === 'object') return Object.keys(rubricsData).length > 0;
        return false;
    };
    const ShowAndHideRubric = useCallback(({ className = "", submissionRubricsData }) => {
        const hasSubmissionRubrics = hasRubricsData(submissionRubricsData);
        const hasAssignmentRubrics = assignmentRubrics && assignmentRubrics.id;
        const hasRubrics = hasSubmissionRubrics || hasAssignmentRubrics;
        if (!hasRubrics) return null;
        return (
            <div className={`${className} show-rubric-container`} style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", fontWeight: "bold", marginBottom: "10px", paddingRight:8 }}>
                <Switch
                    name="viewSpecialSupport"
                    color="primary"
                    size="small"
                    onChange={handleSwitchChange}
                    defaultChecked={assignmentshow}
                    value={assignmentshow}
                />
                {!assignmentshow ? <span className='text-ft11'>Show Rubric</span> : <span className='text-ft11'>Show Response</span>}
            </div>
        )
    },[assignmentshow, assignmentRubrics])
    const handleDownloadPDF = useCallback(async (submissionQuestions, submissionAnswers, submissionId, submissionNumber, submissionForAi) => {
        setGeneratingPDFForId(submissionId);
        const studentName = [get(selectedUser, 'firstName', ''), get(selectedUser, 'lastName', '')]
            .filter(Boolean)
            .join(' ')
            .trim();
        const assignmentDisplayName =
            getDisplayName(submissionData) || getDisplayName(data) || get(assignment, 'displayName', '');
        const className = get(currentClass, 'displayName', '');
        const isReturnedForHeader =
            submissionForAi?.returned > 0 &&
            submissionForAi?.submissions === (submissionForAi?.returned - 1);
        const gradeValue = getAssignmentGradeValue(submissionForAi);
        const isCurrentSubmission = get(submissionForAi, 'id') === get(submissionData, 'id');
        const gradeProp = isCurrentSubmission
            ? (grade_value ||
                  (gradeValue && gradeValue !== '-'
                      ? gradeValue
                      : isReturnedForHeader && isUngraded
                        ? 'Returned'
                        : gradeValue))
            : getGradeWithPreference(submissionForAi, isPointSystem);
        const overallGrade = resolveOverallGradeForPrint({
            grade: gradeProp,
            isUngraded,
            isReturnedForSession: isReturnedForHeader,
            submission: submissionForAi,
            getMarkStatus,
            getMarkStatusBingo,
        });
        const proficiencyLevel = resolveAiGradingLevel({
            submission: submissionForAi,
            activityAssignment: assignment,
            combinedAssignments,
            selectedStudentId: get(selectedUser, 'id') || get(submissionForAi, 'userId'),
            currentClassId: get(currentClass, 'id'),
            currentSubmissionNo: submissionNumber,
        });
        await generateAssignmentPDF({
            pdfContentRef,
            showAlert,
            clearGeneratingState: () => setGeneratingPDFForId(null),
            setPdfData,
            questions: submissionQuestions,
            answers: submissionAnswers,
            studentName,
            assignmentDisplayName,
            className,
            submissionNumber,
            aiGrades: get(submissionForAi, 'ai_grade', []) || [],
            aiFeedbacks: get(submissionForAi, 'ai_feedback', []) || [],
            aiSuggestions: get(submissionForAi, 'ai_suggestion', []) || [],
            overallGrade,
            proficiencyLevel,
        });
    }, [
        showAlert,
        pdfContentRef,
        setPdfData,
        getDisplayName,
        submissionData,
        data,
        assignment,
        selectedUser,
        currentClass,
        combinedAssignments,
        grade_value,
        isUngraded,
        isPointSystem,
        getMarkStatus,
        getMarkStatusBingo,
    ]);
    const pastSubmissionView = useMemo(() => {
        if (!pastSubmissions || pastSubmissions.length === 0) {
            return null;
        }
        return (
            <div>
                {pastSubmissions.map((pt, i) => {
                    const hmark = getHigestMark(pt,true);
                    const is_returned = pt.is_return;
                    const grade = getGradeWithPreference(pt, isPointSystem);
                    let mark = hmark.isHighest ? `Highest(${grade? grade :hmark.val})` : `(${hmark.progress ? "in-progress" : grade? grade :hmark.val})`;
                    mark = isUngraded ? "Credit" : mark;
                    const p_submissions = get(pt, "submissions")
                    const returned_at = get(submissionData, "returned_at") || [];
                    const sessionLogId = getSubmissionActivityLogId(pt);
                    const isReturnedData = find(returned_at, k => k == p_submissions);
                    let PastSub = 0;
                    map(pastSubmissions, pt => (
                        PastSub = parseInt(pt.submissions)
                    ));
                    const LastSub = PastSub ? PastSub : 0;
                    const CurrentSub = LastSub + 1;
                    let Title = "";
                    if (CurrentSub === 1) {
                        Title = pastSubmissions?.length;
                    } else {
                        Title = pastSubmissions?.length + ' (Last Submission)';
                    }
                    const isReturnedForHeader = (Number(pt?.returned) > 0 ?  Number(pt?.submissions) === (Number(pt?.returned) - 1) : false)
                    return (
                        <StyledAccordion square expanded={expanded === pt.id} onChange={handleChangeExpend(pt.id)} key={pt.id}>
                            <StyledAccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                                <AccordianTitle>
                                    <span>{"Submission-" + (i + 1)} {mark} {isReturnedForHeader ? "(Returned)" : null} {isGradedByTeacher(pt,true)}</span>{" "}
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        {get(pt, "answers.length", 0) > 0 && (
                                            <HeaderDownloadButton
                                                type="button"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    const ptQuestions = get(data, "assignment.questions", []);
                                                    const ptAnswers = get(pt, "answers", []);
                                                    handleDownloadPDF(ptQuestions, ptAnswers, pt.id, i + 1, pt);
                                                }}
                                                disabled={!!generatingPDFForId}
                                            >
                                                {generatingPDFForId === pt.id ? (
                                                    <Loading size={14} white />
                                                ) : (
                                                    <>
                                                        <Download fontSize="small" style={{ fontSize: '14px' }} />
                                                    </>
                                                )}
                                            </HeaderDownloadButton>
                                        )}
                                        <Rotate open={expanded === pt.id}><ArrowRight /></Rotate>
                                    </div>
                                </AccordianTitle>
                            </StyledAccordionSummary>
                            {hmark.progress ? (
                             <Notification style={{marginBottom: "0px"}}>
                                     {get(selectedUser, "firstName", "")} {get(selectedUser, "lastName", "")} is in the process of taking this assignment and due to that you might see partial/no answers below. If there is a grade for this assignment it has been stored from a previous submission.
                                 </Notification>
                        ) : null}
                            <StyledAccordionDetails>
                                    <GradeDisplay
                                        answers={pt.answers}
                                        feedback={pt.feedback}
                                        audioFeedback={pt.audioFeedback}
                                        ai_feedback={get(pt, "ai_feedback")}
                                        ai_suggestion={get(pt, "ai_suggestion")}
                                        grade={getGradeWithPreference(pt, isPointSystem)}
                                        name={getDisplayName(data)}
                                        questions={get(data, "assignment.questions", [])}
                                        type={get(data, "assignmentType") === "quiz" ? "quiz" : null}
                                        isExpended
                                        isLate={false}
                                        hasFeedback={true &&(get(pt, "feedback")|| get(pt, "audioFeedback"))}
                                        isUngraded={isUngraded}
                                        assignment={pt}
                                        rubricsToggle={ShowAndHideRubric({submissionRubricsData:get(pt, "rubrics_data")})}
                                        activity={assignment}
                                        in_progress={hmark.progress}
                                        showStudentTrackingButton={Boolean(currentUser?.role && currentUser.role !== 'student' && sessionLogId)}
                                        onStudentTrackingClick={() => {
                                            setTrackingLogId(sessionLogId);
                                            setTrackingSubmissionLabel(`Submission-${p_submissions}`);
                                        }}
                                    />
                            </StyledAccordionDetails>
                        </StyledAccordion>
                    );
                })}
            </div>
        );
    }, [pastSubmissions, expanded, submissionData, ShowAndHideRubric, getGradeWithPreference, selectedUser, isUngraded, data, assignment, isPointSystem, generatingPDFForId, handleDownloadPDF, currentUser]);


    const CurrentSubmissionView = useMemo(() => {
        const graphicOrgInProgress = isGraphicOrgInProgress(submissionData, assignment);
        if (submissionData?.submissions != 0 || (submissionData?.submissions == 0 && (submissionData?.answers?.length > 0 || (submissionData.graded && !submissionData.isTemp) || graphicOrgInProgress))) {
            //const LastSub = pastSubmissions.length +1;
            // const CurrentSub = LastSub + 1;
            let PastSub = 0;
            map(pastSubmissions, pt => (
                PastSub = parseInt(pt.submissions)
            ));
            const LastSub = PastSub ? PastSub : 0;
            const CurrentSub = LastSub + 1;
            let Title = "";
            if (CurrentSub === 1) {
                Title = pastSubmissions?.length + 1;
            } else {
                Title = (pastSubmissions?.length + 1) + ' (Last Submission)';
            }
            const hmark = getHigestMark(submissionData);
            let mark = hmark.isHighest ? `Highest(${hmark.val})` : `(${hmark.progress ? "in-progress" : hmark.val})`;
            const isReturnedForHeader = (submissionData?.returned > 0 && submissionData?.submissions === (submissionData?.returned - 1));
            mark = getSubmissionStatus(submissionData).inProgressStatus || graphicOrgInProgress
                ? ("(In Progress)")
                : isReturnedForHeader && isUngraded
                    ? "Credit"
                    : submissionData?.assignmentType === "bingo"
                        ? getMarkStatusBingo(isUngraded,submissionData?.submissions || 0,submissionData)
                        : getMarkStatus(isUngraded,submissionData?.submissions || 0,submissionData);
            const is_game = submissionData?.assignmentType === "game";
            const is_debate = submissionData?.assignmentType === "debate";
            const is_worksheet = submissionData?.assignmentType === "worksheet";
            const is_loteria = get(submissionData, "assignmentType", '') === "bingo"
            const gradeValue = getAssignmentGradeValue(submissionData);
            const currentSessionLogId = getSubmissionActivityLogId(submissionData);
            return (
                <div>
                    {<StyledAccordion square expanded={expanded === get(submissionData, "id")} onChange={handleChangeExpend(get(submissionData, "id"))}>
                        <StyledAccordionSummary style={CurrentSubmission} aria-controls="panel1d-content" id="panel1d-header">
                            <AccordianTitle>
                                <span>{"Submission-" + Title}  {mark} {isReturnedForHeader ? `(Returned)` : null} {isGradedByTeacher(submissionData,false)}</span>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    {get(submissionData, "answers.length", 0) > 0 && (
                                        <HeaderDownloadButton
                                            type="button"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                const is_worksheet = get(submissionData, "assignmentType") === "worksheet";
                                                const submissionQuestions = is_worksheet
                                                    ? questions
                                                    : get(submissionData, "assignment.questions", []) || get(assignment, "questions", []) || get(data, "assignment.questions", []);
                                                const submissionAnswers = get(submissionData, "answers", []) || [];
                                                handleDownloadPDF(
                                                    submissionQuestions,
                                                    submissionAnswers,
                                                    get(submissionData, "id"),
                                                    pastSubmissions.length + 1,
                                                    submissionData
                                                );
                                            }}
                                            disabled={!!generatingPDFForId}
                                        >
                                            {generatingPDFForId === get(submissionData, "id") ? (
                                                <Loading size={14} white />
                                            ) : (
                                                <>
                                                    <Download fontSize="small" style={{ fontSize: '14px' }} />
                                                </>
                                            )}
                                        </HeaderDownloadButton>
                                    )}
                                    <Rotate open={expanded === get(submissionData, "id")}><ArrowRight /></Rotate>
                                </div>
                            </AccordianTitle>
                        </StyledAccordionSummary>
                        {(getSubmissionStatus(submissionData).inProgressStatus || graphicOrgInProgress) ? (
                             <Notification style={{marginBottom: "0px"}}>
                             {/* get(submissionData,"pastSubmissions.length")==0 */}
                                     {get(selectedUser, "firstName", "")} {get(selectedUser, "lastName", "")} is in the process of taking this assignment and due to that you might see partial/no answers below. If there is a grade for this assignment it has been stored from a previous submission.
                                 </Notification>
                        ) : null}
                        <StyledAccordionDetails style={{padding: "0px"}}>
                                <GradeDisplay
                                    key={get(submissionData, "id")}
                                    answers={get(submissionData, "answers")}
                                    feedback={get(submissionData, "feedback")}
                                    audioFeedback={get(submissionData, "audioFeedback")}
                                    ai_suggestion={get(submissionData, "ai_suggestion")}
                                    ai_feedback={get(submissionData, "ai_feedback")}
                                    grade={grade_value || (gradeValue && gradeValue !== "-" ? gradeValue : (current_assignment_returned ? 'Returned' : gradeValue))}
                                    name={getDisplayName(submissionData)}
                                    questions={is_worksheet?questions:get(submissionData,"assignment.questions", []) || get(assignment, "questions", []) || get(data, "assignment.questions", [])}
                                    type={get(submissionData, "assignmentType") === "quiz" ? "quiz" : null}
                                    isExpended
                                    isLate={false}
                                    is_game={is_game}
                                    is_debate={is_debate}
                                    is_worksheet={is_worksheet}
                                    is_loteria={is_loteria}
                                    isUngraded={isUngraded}
                                    selected_student_id={submissionData?.userId}
                                    hasFeedback={false}
                                    rubricsToggle={ShowAndHideRubric({submissionRubricsData:get(submissionData, "rubrics_data")})}
                                    assignment={submissionData}
                                    show_ai_grade_button={canEditSubmission && checkIsManualGradable(get(submissionData, "assignment.questions", []) || get(assignment, "questions", []) || get(data, "assignment.questions", []))}
                                    activity={assignment}
                                    showReturnButton={canEditSubmission}
                                    isReturnedFromSession={isReturnedForHeader}
                                    currentSubmissionNo={CurrentSub}
                                    onReturnSuccess={onReturnSuccess}
                                    in_progress={hmark.progress}
                                    showStudentTrackingButton={Boolean(currentUser?.role && currentUser.role !== 'student' && currentSessionLogId)}
                                    onStudentTrackingClick={() => {
                                        setTrackingLogId(currentSessionLogId);
                                        setTrackingSubmissionLabel(`Submission-${Title}`);
                                    }}
                                />
                        </StyledAccordionDetails>
                    </StyledAccordion>}
                </div>
            );
        }
        return null;
    }, [submissionData, expanded, pastSubmissions, ShowAndHideRubric, questions, generatingPDFForId, returnedSubmissionIds, onReturnSuccess, grade_value, canEditSubmission, assignment, data, isUngraded, current_assignment_returned, selectedUser, handleDownloadPDF, getSubmissionStatus, currentUser]);

    const updateGradeToCanvas = async (_val) => {
        if (currentUser && currentUser.canvas_id && currentClass.canvas_id) {
            const assignment = concat(classActivities, classQuizzes).find(k => k.quizId === submissionData.assignmentId || k.activityId === submissionData.assignmentId)
            let assignmentId = assignment?.canvas_id
            await handleUpdateCanvasGradeInBatch(currentUser.canvas_id, {
                "canvas_assignment_id": assignmentId,
                "course_id": currentClass.canvas_course_id,
                "canvas_user_id": get(find(classUsers, ["id", get(submissionData, "user.id")]), "canvas_id"),
                "grade": _val
            }, currentUser.canvas_auth_id)
        }
    }
    const updateGradetoSchoology = async(_val, { feedbackText, manualGrading } = {}) => {
        if (currentClass && currentClass.sectionId && submissionData && submissionData.user && submissionData.user.schoologyid) {
            const assignment = concat(classActivities, classQuizzes).find(k => k.quizId === submissionData.assignmentId || k.activityId === submissionData.assignmentId)
            await handleGradeToSchoology({
                sectionId: currentClass?.sectionId,
                schoologyid: currentUser.schoologyid,
                statusCode: null,
                value: _val,
                studentSchoologyIds: [submissionData.user.schoologyid],
                sAssignmentId: assignment?.sAssignmentId,
                manualGrading,
                feedbackText
            })
        }
    }
    const updateGradetoGoogleClassRoom = async (_val) => {
        if (currentClass && currentClass.googleId) {
            try {
                const assignment = concat(classActivities, classQuizzes).find(k => k.quizId === submissionData.assignmentId || k.activityId === submissionData.assignmentId)
                let assignmentId = assignment?.googleId;
                const studentGoogleId = get(find(classUsers, ["id", get(submissionData, "user.id")]), "googleId")
                await handleUpdateGoolgeGradeInBatch(currentUser.googleId, studentGoogleId, currentClass.googleId, assignmentId, _val)
            } catch (error) {
                Sentry.captureException(`580 Error in updateGradetoGoogleClassRoom: ${error}`);
                console.log(error, "issue in update grade to classroom");
            }
        }
    }
    const closeModal = () => {
        setFeedback('');
        setAudioFeedback(null);
        handleClose();
    }
const handleSubmit = async (e, audioFeedbackUrl, updateAndClose, v, feedBackText , gradeMarking ,forceUpdate ) => {
        if (e) {
            e.preventDefault();
        }
        if (isSubmissionEditBlocked(submissionData)) return;
        const has_feedback =  audioFeedbackUrl || feedBackText
        let val = v ? v : grade_value
        if(!val&&val!=0&&!has_feedback)return;
        let tempGrade = val
        if (scale_1_5 && tempGrade <= 4) {
            tempGrade = tempGrade == 0 ? tempGrade : `${(tempGrade * 20) + 10}`
            val = isPointSystem?val:tempGrade
        } if (gradebook_a_f && hasGradeInA_F(tempGrade).hasValue) {
            tempGrade = hasGradeInA_F(tempGrade).value;
            val = isPointSystem?val:tempGrade
        }
        let tempData = { ...submissionData }

        const notifyData = get(tempData, 'assignmentType', '') === 'worksheet' ? assignment : tempData?.assignment;
        const notifyDataChapter = get(tempData, 'assignmentType', '') === 'worksheet' ? assignment?.bookId : tempData?.assignment?.chapter || assignment?.assignment?.chapter;
        const notifyDataPage = get(tempData, 'assignmentType', '') === 'worksheet' ? assignment?.pageId : tempData?.assignment?.page || assignment?.assignment?.page;

        const notificationData = {
            id: v4(),
            classId: get(currentClass, 'id', ''),
            displayName: get(notifyData, 'displayName', '') || assignment?.assignment?.displayName,
            senderId: get(currentUser, 'id', ''),
            receiversId: [].concat(get(tempData, 'userId', '')),
            modified: moment().toISOString(),
            data: {
                chapter: notifyDataChapter,
                page: notifyDataPage,
                id: get(notifyData, 'id', '') || assignment?.assignment?.id,
                assignmentType: get(tempData, 'assignmentType', '') || '',
            },
            message: `Your Teacher Graded this ${get(tempData, 'assignmentType', '') === 'debate' ? 'Debate' : get(tempData, 'assignmentType', '') === 'worksheet' ? 'Grammar Drill' : get(tempData, 'assignmentType', '') === 'game' ? 'Game' : get(tempData, 'assignmentType', '') === 'bingo' ? 'Bingo' : 'Assignment'}`,
            type: 'update_grade',
            userSeen: []
        }
        // if(tempGrade == submissionData?.grade&&!audioFeedbackUrl&&!feedBackText){\
        const t1 = tempGrade == submissionData?.grade && !get(submissionData, "manualGrading", true) && !has_feedback && !forceUpdate
        const t2 =  submissionData.isTemp && `${tempGrade}` == '0' && !has_feedback &&!forceUpdate
        if (!updateAndClose) {
            if (t1||t2) {
                return;
            }
        }
        if (isPointSystem) {
            if(val==0||val>0){
                const per = (val / max_point) * 100;
                tempGrade = per;
            }
           
        }
        setLoading(updateAndClose ? "uc" : "u");
        setUpdateLoading(tempData.userId)
        sendNotifications(notificationData);
        if (!submissionData || !submissionData.id) {
            tempData["grade"] = tempGrade;
            tempData["feedback"] = feedBackText ? feedBackText : feedback;
            tempData["audioFeedback"] = audioFeedbackUrl ? audioFeedbackUrl : audioFeedback;
            tempData["complete"] = false;
            tempData["answers"] = [];
            tempData["graded"] = true;
            tempData["submissions"] = 1;
            tempData["rubrics_data"] =  gradeMarking || {}
        }
        tempData.face_grade = val;
        if(!has_feedback){
            updateGradeToCanvas(isPointSystem ? val : tempGrade)
            updateGradetoGoogleClassRoom(isPointSystem ? val : tempGrade);
        }
        const schoologyFeedbackText = feedBackText || feedback;
        updateGradetoSchoology(isPointSystem ? val : tempGrade, {
            feedbackText: has_feedback && schoologyFeedbackText ? schoologyFeedbackText : undefined,
            manualGrading: has_feedback ? submissionData?.manualGrading : undefined,
        });
        let submissions = null;
        if (get(submissionData, "id")) {
            const isInProgress = !submissionData.complete && submissionData.retaking;
            let submissionCount = submissionData.submissions || 0;
            if (isInProgress) {
                submissionCount = isNaN(submissionCount) ? 1 : parseInt(submissionCount, 10) + 1;
            }
            const dt = {
                id: submissionData.id,
                grade: has_feedback&&submissionData.manualGrading?submissionData.grade:( val > 0 || val == 0 ? tempGrade : null),
                audioFeedback: audioFeedbackUrl ? audioFeedbackUrl : audioFeedback,
                feedback: feedBackText ? feedBackText : feedback,
                face_grade: has_feedback&&submissionData.manualGrading?submissionData.face_grade: (val > 0 || val == 0 ? val : null),
                rubrics_data : gradeMarking || {},
                submissions: isInProgress ? submissionCount : undefined
            }
            submissions = await dispatch(handleUpdateGrade(dt))
        } else {
            submissions = await (dispatch(handleUpdateSubmission(get(submissionData, "id"), {
                answers: submissionData.answers,
                complete: submissionData.complete,
                grade: has_feedback?null:tempGrade,
                submissions: submissionData.submissions,
                retaking: false,
                graded: true,
                feedback: feedBackText ? feedBackText : feedback,
                audioFeedback: audioFeedbackUrl ? audioFeedbackUrl : audioFeedback,
                manualGrading: has_feedback ? submissionData.manualGrading : false,
                face_grade:has_feedback?null: val,
                rubrics_data : gradeMarking || {}
            }, tempData)))

        }
        if (!updateAndClose && submissions?.userId != null) {
                setSubmissionData(sdata=>{
                    if(sdata && sdata.userId===submissions.userId) {
                        const preservedCreatedAt = sdata.createdAt || submissions.createdAt;
                        return {...sdata,...submissions, createdAt: preservedCreatedAt}
                    }
                    else return sdata;
                })
            const updateStudentData = map(allUserSubmissions, k => {
                if (submissions?.userId != null && submissions.userId == k.userId) {
                    const preservedCreatedAt = k.createdAt || submissions.createdAt;
                    return ({ ...k, ...submissions, isTemp: false, createdAt: preservedCreatedAt })
                } else {
                    return k;
                }
            })
            setAllUserSubmissions(updateStudentData)
            // setData({ ...submissionData, ...submissions, isTemp: false })
        }
        setLoading(null);
        setUpdateLoading(null);
        if (updateAndClose) {
            closeModal()
        }
    }
    const getCompleteInclompleteMark = (isComplete, isInComplete, isActive, user) => {
        const isPastDue = isDueDatePassed(user)
        if (isComplete) {
            return <Check style={{ color: isActive ? COLOR.white : COLOR.green100, fontSize: 18 }} />
        } else if (isInComplete || isPastDue) {
            return <Close style={{ color: isActive ? COLOR.white : COLOR.red, fontSize: 18 }} />
        }
        else {
            return <span style={{ color: isActive ? COLOR.white : COLOR.gray100, fontSize: 18 }}  >-</span>
        }
    }

    const sendNotifications = async (notificationData) => {
        try {
            createCollectionNotification(notificationData, get(currentClass, 'id', ''));
        } catch (error) {
            Sentry.captureException(`581 Error in sendNotifications: ${error}`);
            console.log(error, "error")
        }
    }

    const invokSend = (data) => {
        let socket = socketConnection ?? '';
        if (socket) {
            try {
                if (socket.readyState == 3) {
                    reCreateSocket()
                    setTimeout(() => {
                        socket.send(JSON.stringify(data))
                    }, 2000)
                } else {
                    socket.send(JSON.stringify(data))
                }
            } catch (error) {
                Sentry.captureException(`582 Error in invokSend: ${error}`);
                console.log(error, "error")
            }
        }
    }

    const getStatusVal = (dt) => {
        const exception = get(dt, "exceptionStatus");
        const createAt = get(dt, "createdAt")
        const complete = get(dt, "complete")
        const isTemp = get(dt, "isTemp")
        const answers = get(dt, "answers", []);
        const answersLength = Array.isArray(answers) ? answers.length : Object.keys(answers || {}).length;
        const questionsLength = get(dt, "assignment.questions.length", 0);
        const isProgress = getSubmissionStatus(dt).inProgressStatus || isGraphicOrgInProgress(dt, assignment);
        const isGradedByTeacher = get(dt, "submissions") == 0 && get(dt, "answers.length", 0) == 0 && get(dt, "pastSubmissions.length", 0) == 0
        const { grade } = getGradeval(dt)
        if (exception > 0) {
            return "" + exception;
        } else if (isGradedByTeacher && !isTemp && (grade > 0 || ['A', 'B', 'C', 'D', 'F'].includes(grade))) {
            return "Graded Without Submission"
        }
        else if (isProgress) {
            return "In progress"
        }
        else if (complete && createAt) {
            return `Completed on ${moment(parseInt(createAt)).format('MMM DD, YYYY hh:mm A')}`;
        } else if (createAt && !isTemp) {
            return `${moment(parseInt(createAt)).format('MMM DD, YYYY hh:mm A')}`;
        } else {
            return "Not submitted."
        }
    }
    const getStatus = (dt) => {
        const exception = get(dt, "exceptionStatus");
        const createAt = get(dt, "createdAt")
        const complete = get(dt, "complete")
        const isTemp = get(dt, "isTemp")
        // const isProgress = (!get(dt, "complete") && get(dt, "retaking") && dt?.assignmentType === "worksheet" ? get(dt, "id") : get(dt, "assignment.questions.length", 0) > get(dt, "assignment.answers.length", 0));
        const isProgress = getSubmissionStatus(dt).inProgressStatus || isGraphicOrgInProgress(dt, assignment);
        const isGradedByTeacher = get(dt, "submissions") == 0 && get(dt, "answers.length", 0) == 0 && get(dt, "pastSubmissions.length", 0) == 0
        const { grade } = getGradeval(dt)
        if (exception > 0) {
            if (exception == 1) {
                // return <span style={{ color: COLORSTATUS[exception] }}> Excused</span>
                return <span>{currentUser.schoologyid ? "Exempt" : "Excused"}</span>
            } else if (exception == 2) {
                return <span> Incomplete</span>
            } else if (exception == 3) {
                return <span> Missing</span>
            }
        } else if (isGradedByTeacher && !isTemp && grade > 0) {
            return "Graded Without Submission"
        }
        else if (isProgress) {
            return "In progress"
        }
        else if (complete && createAt) {
            return `Completed on ${moment(parseInt(createAt)).format('MMM DD, YYYY hh:mm A')}`;
        } else if (createAt && !isTemp) {
            return `${moment(parseInt(createAt)).format('MMM DD, YYYY hh:mm A')}`;
        } else {
            return "Not submitted."
        }
    }
    const getAssignmentDueOn = useCallback((dt) => {
        if (!dt) return ''
        const userId = dt?.userId;
        const diff = getDiffConfigForStudent(userId, assignment, currentClass.id)
        if (diff) {
            return `${moment(diff.dueDateDif).format('MMM DD, YYYY hh:mm A')}`
        } else {
            return `${moment(assignment?.dueDate).format('MMM DD, YYYY hh:mm A')}`
        }
    }, [assignment])
    const onSortClick = (key) => {
        let v = { ...sortBy }
        v[key] = sortBy[key] === "ASC" ? "DESC" : "ASC"
        setSortBy(v)
        let val = null;
        const alsVal = cloneDeep(allUserSubmissions).map(k => ({ ...k, assignmentStatus: getStatusVal(k) }))
        if (key == "fname") {
            val = alsVal.sort((a, b) => sortname(a, b, "user.firstName", v[key]))
        }
        else if (key == "lname") {
            val = alsVal.sort((a, b) => sortname(a, b, "user.lastName", v[key]))
        } else if (key == "status") {
            val = alsVal.sort((a, b) => sortname(a, b, "assignmentStatus", v[key]))
        }
        setAllUserSubmissions(val ? val : alsVal)
    }

    const filterStudentList = (key) => {
        setSelect(key)
        let val = null;
        switch (key) {
            case "All":
                setAllUserSubmissions(allFilteredUser)
                break;
            case "Missing":
                val = filter(allFilteredUser, obj => obj.exceptionStatus == 3);
                setAllUserSubmissions(val)
                break;
            case "Incomplete":
                val = filter(allFilteredUser, obj => obj.exceptionStatus == 2);
                setAllUserSubmissions(val)
                break;
            case "Excused":
                val = filter(allFilteredUser, obj => obj.exceptionStatus == 1);
                setAllUserSubmissions(val)
                break;
            case "Exempt":
                val = filter(allFilteredUser, obj => obj.exceptionStatus == 1);
                setAllUserSubmissions(val)
                break;
            case "Absent":
                val = filter(allFilteredUser, obj => obj.exceptionStatus == 5);
                setAllUserSubmissions(val)
                break;
            case "Late":
                val = filter(allFilteredUser, obj => obj.exceptionStatus == 6);
                setAllUserSubmissions(val)
                break;
            case "Returned":
                val = filter(allFilteredUser, obj => (obj?.returned > 0 && obj?.submissions == (obj?.returned - 1)));
                setAllUserSubmissions(val)
                break;
            default:
                break;
        }
    }
    const getArrowIcon = (key) => {
        return sortBy[key] == "ASC" ? <ArrowDownward style={{ fontSize: 12 }} /> : sortBy[key] == "DESC" ? <ArrowUpward style={{ fontSize: 12 }} /> : null
    }
    function trimVal(val) {
        if (typeof val == "string") {
            return val.trim();
        }
        return val;
    }
    function getAssignmentGradeValue(dt, assignmentFallback = assignment) {
        const assignment_question = get(dt, "assignment.questions", []);
        const is_graphic_organizer = isGraphicOrganizer(dt, assignmentFallback);
        const isTbg = checkIsManualGradable(assignment_question);
        const is_ai_graded = dt?.ai_grade?.length > 0;
        const manualGrading = get(dt, "manualGrading", false);
        const retaking = get(dt, "retaking", false);
        const isTemp = get(dt, "isTemp");
        const { grade, face_grade } = getGradeval(dt);
        const tbgTxt = isTbg ? (is_graphic_organizer ? "TBG" : (isAiPermissionEnabled ? "TBG - AI" : "TBG")) : "-";
        const showTbg = isTbg && manualGrading && dt.complete;
        if (isPointSystem) {
            return showTbg
                ? trimVal(face_grade)
                    ? `${face_grade} (${tbgTxt})`
                    : is_graphic_organizer ? "TBG" : (isAiPermissionEnabled ? "TBG - AI" : "TBG")
                : face_grade;
        }
        const hasAF = hasGradeInA_F(grade).hasValue;
        if (hasAF) {
            return showTbg && grade != null ? `${grade} (${tbgTxt})` : grade;
        }
        if (isTemp || (!is_ai_graded && retaking && grade == 0)) return "-";
        if (grade != null && (grade > 0 || ((is_ai_graded || !manualGrading) && grade == 0))) {
            return showTbg ? `${grade} (${tbgTxt})` : grade;
        }
        return showTbg ? tbgTxt : "-";
    }
    const onBlurInput = () => {
        document.activeElement.blur();
    }
    const onEnterPress = () => {
        if (assignmentshow) return;
        const hasref = inputsRefs.current.find(e => e == document.activeElement)
        const activeIndex = findIndex(allUserSubmissions, e => get(selectedUser, "id") == get(e, "user.id"))
        if (!hasref) {
            if (inputsRefs.current[activeIndex]) {
                inputsRefs.current[activeIndex].focus();
                inputsRefs.current[activeIndex].select();
            }
        } else {
            if (inputRef.current === document.activeElement) {
                return false;
            }
            onBlurInput()
            let next_index = activeIndex + 1;
            if (activeIndex < allUserSubmissions.length && allUserSubmissions[next_index]) {
                setData(allUserSubmissions[next_index])
                if(inputsRefs.current[next_index]) {
                    inputsRefs.current[next_index].focus();
                    inputsRefs.current[next_index].select();
                }
            }
        }
    }
    const handleKeyDown = useCallback((e) => {
        const activeIndex = findIndex(allUserSubmissions, e => get(selectedUser, "id") == get(e, "user.id"))
        if(is_feedback_input_active.current) return;
        if (activeIndex < 0 || !allUserSubmissions) return;
        const { key } = e;
        switch (key) {
            case "ArrowUp":
            case 38:
                if(assignmentshow) return;
                if (activeIndex > 0 && allUserSubmissions[activeIndex - 1]) {
                    setData(allUserSubmissions[activeIndex - 1])
                    onBlurInput()
                    if (inputsRefs.current[activeIndex - 1]) {
                        inputsRefs.current[activeIndex - 1].focus();
                    }
                }

                break;
            case "ArrowDown":
            case 40:
                if(assignmentshow) return;
                if (activeIndex < allUserSubmissions.length && allUserSubmissions[activeIndex + 1]) {
                    setData(allUserSubmissions[activeIndex + 1])
                    onBlurInput()
                    if (inputsRefs.current[activeIndex + 1]) {
                        inputsRefs.current[activeIndex + 1].focus();
                    }
                }
                break;
            case "Enter":
            case 13:
                onEnterPress();
                break;
            default:
                break;
        }
    }, [allUserSubmissions, selectedUser])
    useEffect(() => {
        window.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };

    }, [handleKeyDown]);
    const handleFocus = (event) => event.target.select();
    const categories = ["All", "Missing", "Incomplete", get(currentUser, "schoologyid") ? "Exempt" : "Excused", "Returned"];
    const categoryNav = () => {
        return {
            items: map(categories, (ct) => ({
                key: ct,
                label: (
                    <PaddedBtn
                        onClick={() => {
                            filterStudentList(ct);
                        }}
                    >
                        {ct}
                    </PaddedBtn>
                ),
                style: { padding: "0px" }
            }))
        };
    };
    function  isReturned (isUngraded, submission)  {
        return !isUngraded && submission && Object.keys(submission || {}).length > 0 && parseInt(get(submission, "submissions")) == (parseInt(get(submission, "returned", 0)) - 1)
    }
    const getMark = (is_returned, isTbg, is_gradable, isActive,in_progress,current_submission) => {
        if (is_returned ) {
            return "Returned";
        }
        else if (!in_progress&&isTbg && is_gradable&&isActive) {
            // const bg_text = current_submission&&current_submission.ai_grade&&current_submission.ai_grade?.length > 0? "TBG - AI": "TBG - AI";
            const is_graphic_organizer = isGraphicOrganizer(current_submission, assignment);
            const bg_text = is_graphic_organizer ? "TBG" : (isAiPermissionEnabled ? "TBG - AI" : "TBG");
            return bg_text;
        } else return null
    }
    const getCompleteIncompleteMark = (isCompleteInComplete, usrAssignments , isActive ) => {
        if (isCompleteInComplete) {
            return getCompleteInclompleteMark(has(usrAssignments, "id") && usrAssignments.grade > 0, has(usrAssignments, "id") && usrAssignments.grade == 0, isActive, get(usrAssignments, "user"));
        }
        return null;
    }
    const getUngradedMark = (isUngraded, current_submission,usrAssignments) => {
        if (isUngraded) {
            const returnedState = parseInt(get(usrAssignments, "returned", 0)) === parseInt(current_submission || 0) + 1;
            return getSubmissionStatus(usrAssignments).inProgressStatus ? "-" : ((current_submission > 0 || returnedState) ? "Credit" : "-")
        }
        return '';
    }
    const getUngradedMarkBingo = (isUngraded, current_submission,userAssignment) => {
        if (isUngraded) {
            const isSubmitted = userAssignment?.answers?.length > 0 ? userAssignment?.answers?.some((el)=> el?.is_submitted):false;
            const returnedState = parseInt(get(userAssignment, "returned", 0)) === parseInt(current_submission || 0) + 1;
            return getSubmissionStatus(userAssignment).inProgressStatus ? "-" : ((current_submission > 0 && isSubmitted) || returnedState ? "Credit" : "-")
        }
        return '';
    }
    const getUserName = (usrAssignments) => {
        const resolvedUser = getResolvedStudentUser(get(usrAssignments, "user", {}), get(usrAssignments, "userId"));
        const first_name = get(resolvedUser, "firstName", "");
        const last_name = get(resolvedUser, "lastName", "");
        return <NameText className='text-wrap'>{first_name} {last_name}</NameText>
    }
    const getNonActiveText = (usrAssignments, assignment_grade_data,is_temp) => {
        const v = !is_temp && (typeof assignment_grade_data === "number" && assignment_grade_data >= 0) || (typeof assignment_grade_data === "string" && assignment_grade_data.length) ? assignment_grade_data : '-';
        const validAiFeedback = hasValidAiFeedback(usrAssignments);
        if(!validAiFeedback) {
            return <span style={{ margin: 2, whiteSpace: "nowrap" }}>-</span>;
        }
        return (<span style={{ margin: 2, whiteSpace: "nowrap" }}>
            {v}   {isPointSystem ? <MaxPointText style={{ color: get(selectedUser, "id") == get(usrAssignments, "user.id") ? "#fff" : COLOR.gray100, marginRight: 5 }}>{`/${max_point}`}</MaxPointText> : null}
        </span>)
    }
    const userList = useMemo(() => {
        return allUserSubmissions.length > 0 ? map(allUserSubmissions, (usrAssignments, i) => {
            const current_user_id = get(usrAssignments, "user.id");
            const is_user_active =  get(usrAssignments, "user.active");
            const current_submission = get(usrAssignments, "submissions");
            const selected_user_id = get(selectedUser, "id");
            const isActive = selected_user_id === current_user_id
            const is_loading = updateLoading == current_user_id && updateLoading;
            const is_gradable = !isUngraded && !isCompleteInComplete;
            const current_assignment_grade = getAssignmentGradeValue(usrAssignments)
            const isTbg = checkIsTbgTxt(current_assignment_grade);
            const is_returned = isReturned(isUngraded,usrAssignments)
            const value_result = (typeof grade_value === "number" && grade_value >= 0) || (typeof grade_value === "string") ? grade_value : '-';
            const in_progress = getSubmissionStatus(usrAssignments).inProgressStatus
            if(!is_user_active){
                return null;
            }
            const isDoneLate = isDoneLateSubmission(usrAssignments);
            const validAiFeedback = hasValidAiFeedback(submissionData);
            return (
                <>
                <UserSelector className='user-select-list-review' onClick={(event) => {
                        if(!is_mobile_menu){
                            event.stopPropagation();
                            setData(usrAssignments);
                            setSelectedUser(prev => {
                                const data = {...prev}
                                data.isPreview = true;
                                return data;
                            })
                        }
                    }}   key={current_user_id} active={isActive} $user_not_active={is_user_active !== undefined ? !is_user_active : false}>
                    <div onClick={(event) => {
                        if(is_mobile_menu){
                            event.stopPropagation();
                            setData(usrAssignments);
                            setSelectedUser(prev => {
                                const data = {...prev}
                                data.isPreview = true;
                                return data;
                            })
                            setSelectedUserChange(prev => {
                                const data = {...prev}
                                data.isPreview = true;
                                return data;
                            })
                        }
                    }} className='flex items-center'>
                        <EyeOutlined className='eye-icon-assignment-review' style={{marginRight: "10px"}} 
                       />
                        <Tooltip showArrow={false} overlayClassName='student-review-tooltip' placement='top' title={getUserName(usrAssignments)} >
                            <span className='text-wrap d-inline-flex'>{getUserName(usrAssignments)}</span>
                        </Tooltip>
                    </div>
                  
                  <div onClick={(event) => {
                        if(is_mobile_menu){
                            event.stopPropagation();
                            setData(usrAssignments);
                            setSelectedUser(prev => {
                                const data = {...prev}
                                data.isPreview = true;
                                return data;
                            })
                            setSelectedUserChange(prev => {
                                const data = {...prev}
                                data.isPreview = true;
                                return data;
                            })
                        }  
                    }}  className='flex items-center w-full justify-center'>
                  {is_loading ? <Loading size={14} white={isActive} /> : null}
                    {!validAiFeedback? null : usrAssignments?.assignmentType === "bingo" ?getUngradedMarkBingo(isUngraded,current_submission, usrAssignments) :getUngradedMark(isUngraded,current_submission,usrAssignments)}
                    {!validAiFeedback? null : getMark(is_returned,isTbg,is_gradable,isActive,in_progress,usrAssignments)}
                    {!validAiFeedback? null : getCompleteIncompleteMark(isCompleteInComplete,usrAssignments,isActive)}
                    {is_gradable ? <>
                        {isActive ? (
                            <div style={{ position: "relative", padding: '5px' }}>
                            {isDoneLate && getStatus(usrAssignments) != 'In progress' ? <span className="doneLatePosition" style={{marginRight: "2px"}}>Done late</span> : ""}
                            <GradeEditorInput
                                style={{paddingInline: "2px", margin:"0px 5px"}}
                                disabled={!validAiFeedback || updateLoading || get(usrAssignments, "exceptionStatus") > 0 || isUngraded || isSubmissionEditBlocked(usrAssignments) || !is_user_active || !assignedStudentList}
                                inputRef={re => inputsRefs.current[i] = re}
                                onChange={handleChange}
                                isLate={isDoneLate}
                                onFocus={e => {
                                    if(e.target.value === "-"){
                                        e.target.value = ''
                                    }
                                    handleFocus(e)
                                }}
                                value={!validAiFeedback? "-" : !assignedStudentList ? "N/A" : value_result}
                                onBlur={(e) => {
                                    if (e && e.target && e.target.value === '') {
                                        setDefaultValue();
                                    }
                                    const v = e&&e.target?e.target.value:value_result
                                    if (typeof v =="string" &&(updateLoading || checkIsTbgTxt(v)|| v.includes("-") || v === '' || v === null)) return;
                                    if(usrAssignments&&!usrAssignments.manualGrading &&(isPointSystem?v==usrAssignments.face_grade : v==usrAssignments.grade)) return;
                                    handleSubmit(e, null, false, v);
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.code === 'Enter' || e.keyCode === 13) {
                                        e.preventDefault();
                                        const v = e&&e.target?e.target.value:value_result
                                        onEnterPress()
                                        if(v == '' || v == null || v=='-' || v=='--') return;
                                        if(usrAssignments&&!usrAssignments.manualGrading &&  usrAssignments &&(isPointSystem?v==usrAssignments.face_grade : v==usrAssignments.grade)) return;
                                        handleSubmit(e, null, false, v, null, null, true);
                                    }
                                    else if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
                                        if (e && e.target && (updateLoading || checkIsTbgTxt(e.target.value) || e.target.value.includes("-") || e.target.value === '' || e.target.value === null)) return;
                                        const v = e&&e.target?e.target.value:value_result
                                        if(usrAssignments&&!usrAssignments.manualGrading &&(isPointSystem?v==usrAssignments.face_grade : v==usrAssignments.grade)) return;
                                        handleSubmit(e, null, false, e && e.target && e.target.value);
                                    }
                                }}
                            />
                            </div>
                        )
                            : getNonActiveText(usrAssignments,current_assignment_grade,usrAssignments.isTemp)
                           }
                    </> : null}
                    {isPointSystem && isActive ? <MaxPointText style={{ color:isActive ? "#fff" : COLOR.gray100, marginRight: 5,whiteSpace: "nowrap" }}>{`/${max_point}`}</MaxPointText> : null}
                  </div>
                    <NameText  onClick={(event) => {
                        if(is_mobile_menu){
                            event.stopPropagation();
                            setData(usrAssignments);
                            setSelectedUser(prev => ({...prev, isPreview: true}));
                            setSelectedUserChange(prev => ({...prev, isPreview: true}));
                        }  
                    }} style={{ width: "100%", textAlign: "right" }}>
                    {usrAssignments?.complete && usrAssignments?.createdAt ? (
                        <Tooltip destroyOnHidden={true}  classNames={{body: 'student-review-tooltip'}} showArrow={false} placement='top' title={getStatus(usrAssignments)}>
                           {getStatus(usrAssignments)}
                        </Tooltip>
                     ) : (
                        <>
                           {getStatus(usrAssignments)}
                        </>
                     )}
                    </NameText>        
                </UserSelector>
                </>
            )
        })
            : <div style={{ textAlign: "center", marginTop: "20px" }}>No Data Found</div>
    }, [allUserSubmissions, selectedUser , assignment , updateLoading , isUngraded , grade_value ])
    const pageCover = usePageCover({ assignmentData: assignment?.data });
    const page_src = useMemo(() => {
        if (!get(data, "assignment")) return null;
        if(pageCover){
            return pageCover;
        }
        const assignment_chapter = get(data, "chapter") ? get(data, "chapter") : get(data, "assignment.chapter")
        const cover_img_ext = getCoverForAssignment(submissionData)
        if (cover_img_ext) return cover_img_ext;
        return isVideo(assignment_chapter, resources) ? imageFetchFromPodcast(assignment_chapter, resources) : imageFetch(booksAllList, assignment_chapter, get(data, "assignment.page"))
    }, [submissionData, data, resources,pageCover])

    const is_soy_story = useMemo(() => submissionData && ((typeof submissionData?.assignment?.storyInstruction == "string" && submissionData?.assignment?.storyInstruction.length > 0) || (submissionData?.data && typeof submissionData?.data.storyInstruction == "string" && submissionData?.data.storyInstruction.length > 0)), [submissionData])
    const coverTitle = useAssignmentCoverTitle({ assignment: submissionData, title: getDisplayName(submissionData) });
    const PosterIg = useMemo(() => {
        if (!get(data, "assignment")) return null;
        return (<ImageContiner className='relative'>
            {/* <Image style={{ width: is_mobile_menu && "39px", height: is_mobile_menu && "51px", cursor: "pointer" }} src={page_src} alt='ebook image' className='cursor-pointer' /> */}
            <Image style={{ width: is_mobile_menu && "38px", height: is_mobile_menu && "39px", cursor: "pointer", objectFit:'contain' }} src={page_src} alt='ebook image' className='cursor-pointer' />
             {coverTitle ? <ImageStoryTitle className='customImgTitleReview' fontSize={"3px"}>{coverTitle}</ImageStoryTitle> : null}
        </ImageContiner>)
    }, [coverTitle, page_src,is_mobile_menu,submissionData])

  
    const handleRubricUpdate = (gradeMarking, totalGrade) => {
        if (!canEditSubmission) return;
        const rubric_max_point = assignmentRubrics && assignmentRubrics.rubrics_meta ? assignmentRubrics.rubrics_meta.reduce((sum, criterion) => sum + Math.max(...criterion.points.map(point => point.pointText)), 0) : max_point;
        const percent = Math.round((totalGrade / rubric_max_point) * 100);
        let face_value = 0;
        if(max_point){
            const assignment_max_point = max_point;
            if (rubric_max_point != assignment_max_point) {
                face_value = Math.round((percent / 100) * assignment_max_point);
            } else {
                face_value = totalGrade;
            }
        }else{
            face_value = totalGrade;
        }
        handleSubmit(null, null, false, isPointSystem ? face_value : percent, null, gradeMarking)
    }


    const [isSwitchChecked, setIsSwitchChecked] = useState(false);
    // const [sizes, setSizes] = React.useState([60, 40]);

  const [sizes, setSizes] = useState([600, 500]);
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth >= 1024);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handlePaneResize = (newSizes) => {
    if (isLargeScreen) {
      const screenWidth = window.innerWidth;
      
      const minSizePane1 = 600;
      const minSizePane2 = 500;
      const maxSizePane1 = screenWidth * 0.6;  // 60% of screen width
      const maxSizePane2 = screenWidth * 0.8;  // 80% of screen width
  
      const adjustedSizes = [
        Math.min(Math.max(newSizes[0], minSizePane1), maxSizePane1),
        Math.min(Math.max(newSizes[1], minSizePane2), maxSizePane2)
      ];
      
      setSizes(adjustedSizes);
    } else {
      setSizes(newSizes);
    }
  };

  const getEligibleSubmissions = useMemo(() => {
    return allUserSubmissions.filter((usrAssignment) => {
      const is_user_active = get(usrAssignment, "user.active");
      if (!is_user_active) return false;

      const current_submission = get(usrAssignment, "submissions");
      const is_complete = get(usrAssignment, "complete", false);
      const answersLength = get(usrAssignment, "answers.length", 0);
      
      const questions = get(usrAssignment, "assignment.questions", []) || 
                       get(assignment, "questions", []) || 
                       get(data, "assignment.questions", []);
      
      const show_ai_grade_button = checkIsManualGradable(questions);
      
      const activites = find(combinedAssignments, v => 
        v?.data?.id == usrAssignment?.assignmentId || 
        v?.quizId === usrAssignment?.assignmentId || 
        v?.activityId === usrAssignment?.assignmentId || 
        v?.seesion_id === usrAssignment?.assignmentId
      )?.data;
      
      const is_graphic_organizer = activites?.activity_type === "graphic_organizer";
      
      return show_ai_grade_button && 
             !is_graphic_organizer && 
             answersLength > 0 && 
             is_complete;
    });
  }, [allUserSubmissions, assignment, data, combinedAssignments]);


   const ImagePoster = () => {
     return (
       <div>
         <div
           onClick={() => {
             setModalOpen(true);
           }}
           style={{
             width: is_mobile_menu ? '33px' : '69px',
             height: is_mobile_menu ? '43px' : '84px',
             cursor: 'pointer',
           }}
         >
           {PosterIg}
         </div>
         {is_mobile_menu ? null : (
           <AssignmentImg
             style={{
               display: 'flex',
               alignItems: 'center',
               justifyContent: 'center',
               cursor: 'pointer',
             }}
             onClick={() => {
               setModalOpen(true);
             }}
           >
             <EyeOutlined />
           </AssignmentImg>
         )}
       </div>
     );
   };

  function panel1(){
    return (
      <div
        xs={24}
        sm={24}
        md={24}
        xl={15}
        lg={tabletType ? 24 : 10}
        style={{
          marginBottom: 14,
          flex: "1 1 auto"
        }}
      >
        <div style={{ display: "flex" }} className="viewAssignmentRgt">
          {!is_mobile_menu && <ImagePoster />}

          <div style={{ width: "100%" }}>
            <UserAddignmentLabel className="viewSubmissionMB">
                <div className='flex items-center' style={{ width: '100%' }}>
                    <HeaderWrapper style={{ width: '100%' }}>
                        <div className='flex items-center'>
                            {is_mobile_menu && (
                            <div  onClick={() => {
                                setModalOpen(true)
                            }}>
                            {PosterIg}
                            </div>
                            )}
                            <strong className='ml-4px' style={{ marginRight: !is_mobile_menu ?  "6px"  :"" }}>Student:</strong>
                            <div className=''>
                                    {is_mobile_menu ? (
                                    <>
                                    {SelectedUserDropDown()}
                                    </>
                                ): (
                                    <>
                                    <span style={{ marginRight: "3px" }}>
                                        {get(selectedUser, "firstName", "")}{" "}
                                        {get(selectedUser, "lastName", "")}
                                    </span>{" "}
                                    </>
                                )}
                            </div>
                        </div>
                        <div>
                            <strong style={{ marginLeft: "3px", marginRight: "6px" }}>
                                | {" "}
                                Status:{" "}
                            </strong>{" "}
                            {getStatus(submissionData)}
                        </div>
                        <div>
                            {" "}
                            <strong style={{ marginLeft: "3px", marginRight: "6px" }}>
                                |{" "}Due on:{" "}
                            </strong>{" "}
                            {getAssignmentDueOn(submissionData)}
                        </div>
                    </HeaderWrapper>
                </div>
            
            </UserAddignmentLabel>
           

                    {inProgressStatus && (
                 <>
                     {allUserSubmissions?.length === 0 && (
                        <>
                        <Notification>
                        {/* get(submissionData,"pastSubmissions.length")==0 */}
                                {get(selectedUser, "firstName", "")} {get(selectedUser, "lastName", "")} is in the process of taking this assignment and due to that you might see partial/no answers below. If there is a grade for this assignment it has been stored from a previous submission.
                            </Notification>
                            <SubmissionMessage className='submission-image-container' style={{flexDirection: "column"}}>
                                 Submission in progress
                                <div className='mt-10px '>
                                    <img className='image-for-open-submission' src={assignmentImage} alt='submissionImage'/>
                                </div>
                            </SubmissionMessage>
                        </>
                        
                     )}
                            
                            </>
                        )}
                        {submissionStatus && (
                            <>
                            {/* <Notification bgColor={COLOR.yellow} color={COLOR.white}>
                                The student has not submitted this assignment.
                            </Notification> */}
                            <SubmissionMessages className='submission-image-container' style={{flexDirection: "column"}}>
                                No submission available
                                <div className='mt-10px '>
                                    <img className='image-for-open-submission' src={assignmentImage} alt='submissionImage'/>
                                </div>
                            </SubmissionMessages>
                            </>
                            
                        )}
                        {/* {timmerStatus && (
                            <Notification>
                                This is a time-test assessment, if there are any blank answers, it means the student did not complete within time given.
                            </Notification>
                        )} */}
            <PreviewArea style={{minHeight:expanded === get(submissionData, "id") ? "150px" : "0px"}}>
              {pastSubmissionView}
              {CurrentSubmissionView}
            {!pastSubmissions.some((pt) => expanded === pt.id) &&
              expanded !== get(submissionData, "id") && (
                <>
                <SubmissionMessage className='submission-image-container submission-image-container-open-submission' style={{flexDirection: "column"}}>
                  Open a submission to see responses
                  <div className='mt-10px '>
                    <img className='image-for-open-submission' src={openSubMissionImage} alt='submissionImage'/>
                </div>
                </SubmissionMessage>
                </>
              )}
            </PreviewArea>
          </div>
        </div>
      </div>
    );
  };

  const Panel2 = () => {
    return (
      <div
        xs={24}
        sm={24}
        md={7}
        xl={9}
        style={{
          marginBottom: 14,
          //   width: "300px",
          // width:"575px",
          marginLeft: "10px",
          flexShrink: 0,
        }}
      >
        {(!assignmentshow|| !assignmentRubrics) ? (
          <div>
            {UserSelectList()}
           {AudioFeedBack()}
           {GradeField()}
          </div>
        ) : (
          <GradebookRubrics
            assignmentRubrics={assignmentRubrics}
            currentSubmissionRubric={currentSubmissionRubric}
            pastSubmissionRubric={pastSubmissionRubric}
            loading={loading == "u"}
            handleRubricUpdate={handleRubricUpdate}
            rubricSection={true}
            allUserSubmissions={allUserSubmissions}
            ai_grade_feedback={ai_grade_feedback}
            onStudentClick={(key) => {
              setData(key);
            }}
          />
        )}
      </div>
    );
  };

  const UserSelectList = () => {
    return (

        <>
        <div className="viewAssignmentLft">
        <UserSelector className='userSelectorAssignmentReview' style={{ height: "auto", marginTop: 0 }}>
          <strong style={{ minWidth: 60 }}>Filter Student</strong>

          <Dropdown
           menu={categoryNav()}
           placement="bottomLeft"
           trigger={['click', 'touch']} 
        //    getPopupContainer={(trigger) => trigger.parentNode}
           >
            <CategoryMenu>
              {select} <MenuIconImg src={MenuIcon} />{" "}
            </CategoryMenu>
          </Dropdown>
        </UserSelector>
        <UserSelector className='sortContainerAssignmentReview' style={{ height: "auto", marginTop: 10 }}>
          <strong style={{ minWidth: 60 }}>Sort by</strong>
          <SortingButton
            className='sortByButtonAssignmentReview'
            active={sortBy.fname}
            onClick={() => {
              onSortClick("fname");
            }}
          >
            {getArrowIcon("fname")} First name
          </SortingButton>
          <SortingButton
            className='sortByButtonAssignmentReview'
            active={sortBy.lname}
            onClick={() => {
              onSortClick("lname");
            }}
          >
            {getArrowIcon("lname")} Last name
          </SortingButton>
          <SortingButton
            className='sortByButtonAssignmentReview'
            active={sortBy.status}
            onClick={() => {
              onSortClick("status");
            }}
          >
            {getArrowIcon("status")}Status
          </SortingButton>
        </UserSelector>
        <UserSelectorList checkFrame={checkFrame}>{userList}
        <div>
        <AssignmentDeviceModal 
            className="max-w-581px" 
            modalOpen={modalOpens} 
            setModalOpen={setModalOpens} 
            onClose={handleCloseModal}
        />
        </div>
        </UserSelectorList>
      </div>
      </>
    )
  }


  const AudioFeedBack = (nav) => {
    return (
        <>
         <Row className='' style={{ paddingInline: is_mobile_menu ?  "20px" : "", marginBottom: is_mobile_menu ? "10px": "24px", marginTop: is_mobile_menu ? 0 :12 }}>
            <div className='flex items-center justify-between w-full'>
            <Description
                style={{
                  marginBottom: 0,
                  opacity:
                    !submissionData || !submissionData.id || !hasGradeForFeedback ? 0.5 : 1,
                }}
              >
                Feedback for student
              </Description>

              {/* {is_mobile_menu && <ShowAndHideRubric />} */}
            </div>
   
              <TextField
                id="feedback"
                onChange={handleFeedback}
                disabled={
                  !submissionData ||
                  !submissionData.id ||
                  !assignedStudentList ||
                  !hasGradeForFeedback ||
                  !canEditSubmission
                }
                variant="outlined"
                onFocus={() => {
                    is_feedback_input_active.current = true;
                }}
                value={feedback}
                multiline
                rows={10}
                placeholder="Type feedback here."
                onBlur={(e) => {
                    is_feedback_input_active.current = false;
                    if (e.target.value && e.target.value.trim().length > 0) {
                        if (hasGradeForFeedback) {
                            handleSubmit(null, null, false, null, e.target.value);
                        } else {
                            setAlertSakeBar({
                                open: true,
                                message: "Please grade the assignment before submitting feedback.",
                                severity: "error",
                            });
                        }
                    }
                }}
                className={"feedbackform viewStudntFeedback tab-mob-assignment-field"}
              />
            </Row>
            {submissionData && submissionData.id ? (
              <Row className='record-feedback-submission-container'>
                <Description
                  style={{
                    marginBottom: 0,
                    opacity: hasGradeForFeedback ? 1 : 0.5,
                  }}
                >
                 Record your feedback for the student
                </Description>
                {nav === "mobileNav" ? (
                    <div className='flex gap-10px w-full justify-between audio-recorder-nav newAssignmentBtn'>
                        <AssignmentRecorder
                        maxTime={120}
                        wrapperStyle={{
                            border: "0px solid #e8e8e8",
                            padding: "0px 0px 0px",
                            marginBottom: is_mobile_menu && "0px"
                        }}
                        ref={feedbackAudioRef}
                        message={"Record your Feedback"}
                        handleAudio={(url) => {
                            if (!hasGradeForFeedback || !canEditSubmission) return;
                            setAudioFeedback(url);
                            handleSubmit(null, url, false);
                        }}
                        refresh={() => navigate(0)}
                        source={audioFeedback}
                        hasSaveButton={Boolean(
                          submissionData && submissionData.id && hasGradeForFeedback && canEditSubmission,
                        )}
                        type={"assignment-review"}
                        isMobileDevice={is_mobile_menu}
                        disabled={!assignedStudentList || !hasGradeForFeedback || !canEditSubmission}
                        />
                        {GradeField()}
                        </div>
                            
                ) : (
                    <> <AssignmentRecorder
                    maxTime={120}
                    wrapperStyle={{
                        border: "0px solid #e8e8e8",
                        padding: "0px 0px 0px",
                    }}
                    ref={feedbackAudioRef}
                    message={"Record your Feedback"}
                    handleAudio={(url) => {
                        if (!hasGradeForFeedback || !canEditSubmission) return;
                        setAudioFeedback(url);
                        handleSubmit(null, url, false);
                    }}
                    refresh={() => navigate(0)}
                    source={audioFeedback}
                    hasSaveButton={Boolean(
                      submissionData && submissionData.id && hasGradeForFeedback && canEditSubmission,
                    )}
                    type={"assignment-review"}
                    isMobileDevice={is_mobile_menu}
                    disabled={!assignedStudentList || !hasGradeForFeedback || !canEditSubmission}
                    /></>
                )}
               
              </Row>
            ) : null}
        </>
    )
  }

  const GradeField = () => {
    const validAiFeedback = hasValidAiFeedback(submissionData);
    return (
        <div
        style={{
          display: "flex",
          alignItems: "start",
          justifyContent: "flex-end",
          marginTop: "30px",
        }}
        className='grade-assignment-review'
      >
        <Row justify="end" style={{gap: '5px'}}>
          {isUngraded || isCompleteInComplete ? null : (
            <div className="viewGradeSection">
              <TextField
                id="grade"
                label="Grade"
                onChange={handleChange}
                onKeyDown={(e) => {
                  if (e.key !== 'Enter') return;
                  e.preventDefault();
                  const isUpdateDisabled =
                    !validAiFeedback ||
                    loading ||
                    updateLoading ||
                    isUngraded ||
                    !canEditSubmission ||
                    grade_value === "-" ||
                    grade_value === null ||
                    grade_value === "" ||
                    isSwitchChecked ||
                    !assignedStudentList;
                  if (isUpdateDisabled) return;
                  const gradeInput = e.target?.value ?? grade_value;
                  if (gradeInput === '' || gradeInput === null || gradeInput === '-') return;
                  handleSubmit(e, null, false, gradeInput);
                }}
                variant="outlined"
                // value={typeof grade === "number" && grade >= 0 || typeof grade === "string" && grade.length > 0 ? grade : ''}
                value={
                  !validAiFeedback? "-" :
                  (typeof rubricScore === "number" && rubricScore >= 0) ||
                  (typeof rubricScore === "string" &&
                    rubricScore.length > 0)
                    ? rubricScore
                    : (typeof grade_value === "number" && grade_value >= 0) ||
                      (typeof grade_value === "string" && grade_value.length > 0)
                    ? !assignedStudentList ? "N/A" : grade_value
                    : ""
                }
                ref={inputRef}
                onFocus={handleFocus}
                style={{
                  marginRight: isPointSystem ? 0 : "16px",
                  width: "62px",
                  paddingTop: "6px",
                  textAlign: "center"
                }}
                className={"gradeUpdate"}
                disabled={
                  !validAiFeedback ||
                  get(submissionData, "exceptionStatus") > 0 ||
                  !canEditSubmission ||
                  !get(submissionData, "user.active", true) || !assignedStudentList
                }
                InputProps={{
                    style: {
                      height: is_mobile_menu ? "28px" : "40px"
                    }
                  }}
              />
              <div style={{ paddingLeft: 15 }}>
                {!validAiFeedback? null : current_assignment_returned
                  ? "returned"
                  : selected_assignment_tbg
                  ? is_graphic_organizer_assignment ? "TBG" : (isAiPermissionEnabled ? "TBG - AI" : "TBG")
                  : ""}
              </div>
            </div>
          )}
          {isPointSystem ? (
            <MaxPointText
              style={{
                marginRight: 16,
                alignSelf: "center",
                fontSize: "large",
              }}
            >{`/${max_point}`}</MaxPointText>
          ) : null}
        <Row justify="end" style={{gap: '5px'}}>
          <Button
            variant="contained"
            color="primary"
            type="submit"
            style={{ height:is_mobile_menu ? "29px" : "36px", marginTop: "2px" }}
            // disabled={loading || updateLoading || isUngraded || get(submissionData, "disableEdit") || grade === '-' || grade === null || grade === ''}
            disabled={
              !validAiFeedback ||
              loading ||
              updateLoading ||
              isUngraded ||
              !canEditSubmission ||
              grade_value === "-" ||
              grade_value === null ||
              grade_value === "" ||
              isSwitchChecked || !assignedStudentList
            }
            onClick={(e) => {
              handleSubmit(e, null, false);
              // closeModal()
            }}
          >
            {loading == "u" ? <Loading size={20} white /> : "Update"}
          </Button>
          <Button
            variant="contained"
            color="primary"
            type="submit"
            style={{ height:is_mobile_menu ? "29px" : "36px", marginTop: "2px" }}
            // disabled={loading || updateLoading || isUngraded || get(submissionData, "disableEdit")}
            disabled={
              !validAiFeedback ||
              loading ||
              updateLoading ||
              isUngraded ||
              !canEditSubmission ||
              isSwitchChecked
            }
            onClick={(e) => {
              handleSubmit(e, null, true);
            }}
          >
            {loading == "uc" ? (
              <Loading size={20} white />
            ) : (
              "Close"
            )}
          </Button>
        </Row>
        </Row>
      </div>
    )
  }




  const backwardForward = (action) => {
    const activeIndex = findIndex(allUserSubmissions, e => get(selectedUser, "id") == get(e, "user.id"))
    if (activeIndex < 0 || !allUserSubmissions) return;

    if(action === "backward"){
        // if(selectedUser?.isShowRubric || assignmentshow) return;

        if (activeIndex > 0 && allUserSubmissions[activeIndex - 1]) {
            const data = allUserSubmissions[activeIndex - 1];
            const user = data?.user;
            user.isPreview = selectedUser?.isPreview ? true : false;
            user.isShowRubric = selectedUser?.isShowRubric ? true : false;
            setSelectedUser(user);
            setSubmissionData(data);
            onBlurInput()
            if (inputsRefs.current[activeIndex - 1]) {
                inputsRefs.current[activeIndex - 1].focus();
            }
        }
    }
    else {
        // if(selectedUser?.isShowRubric || assignmentshow) return;

        if (activeIndex < allUserSubmissions.length && allUserSubmissions[activeIndex + 1]) {
            const data = allUserSubmissions[activeIndex + 1];
            const user = data?.user;
            user.isPreview = selectedUser?.isPreview ? true : false;
            user.isShowRubric = selectedUser?.isShowRubric ? true : false;
            setSelectedUser(user);
            setSubmissionData(data);
            onBlurInput()
            if (inputsRefs.current[activeIndex + 1]) {
                inputsRefs.current[activeIndex + 1].focus();
            }
        }
    }
  };




  const MobileNavSubmission = () => {
    return (
      <div className="arrow-icon-container">
        <button
          className="button-for-mob-nav left-button-submission-review"
          onClick={() => backwardForward("backward", selectedUser)}
        >
          <ChevronLeftOutlined className='arrow-icon' style={{ color: "black" }} />
        </button>
        <div className='w-full'>
        {AudioFeedBack("mobileNav")}
        </div>

        <button
          className="button-for-mob-nav right-button-submission-review"
          onClick={() => backwardForward("forward", selectedUser)}
        >
          <ChevronRightOutlined className='arrow-icon' style={{ color: "black" }} />
        </button>
      </div>
    );
  };


  const categoryAllStudent = () => {
    return {
        items: map(allUserSubmissions, (ct, index) => {
            if(!ct?.user?.active){
                return null;
            }
            return ({
            key: index,
            label: (
                <PaddedBtn
                    onClick={() => {
                        setIsOpen(false);
                        const user = ct?.user;
                        user.isPreview = selectedUser?.isPreview ? true : false;
                        user.isShowRubric = selectedUser?.isShowRubric ? true : false;
                        setSubmissionData(ct);
                        setSelectedUser(user);
                        setSelectedUserChange(user);
                    }}
                >
                    {getUserName(ct)}
                </PaddedBtn>
            ),
            style: { padding: "0px" }
        })}),
    };
};

  const SelectedUserDropDown = () => {
    const handleTouchStart = (e) => {
        e.preventDefault();  // Prevent default touch behavior
    };
    return (
    <div className='selectedUser' style={{ height: "auto",width: "100%", touchAction: 'manipulation',  // Improves touch handling
        cursor: 'pointer', marginLeft:'5px' }}>
            <Dropdown  onOpenChange={handleDropdownVisibleChange} style={{ minWidth: "240px"}} menu={categoryAllStudent()} placement="bottomLeft"  trigger={['click', 'touch']}  getPopupContainer={(trigger) => trigger.parentNode}   overlayClassName="category-all-student-dropdown optionsListMenuEbook">
                <CategoryMenu style={{fontSize: "12px" , height : "24px"}} className='text-wrap d-flex w-full' onTouchStart={handleTouchStart}>
               <span style={{maxWidth: "160px"}} className='text-wrap'>
                {get(selectedUser, "firstName", "")} {" "}
                {get(selectedUser, "lastName", "")}
               </span>

                <RotatingArrow isOpen={isOpen}>
                    <KeyboardArrowDownOutlined />
                </RotatingArrow>
                    </CategoryMenu>
            </Dropdown>
    </div>
    )
  }

  useEffect(() => {
    if(!open){
        setSelectedUser({});
        setSubmissionData({});
    }
  },[open])

  useEffect(() => {
    if (open) {
      document.body.classList.add("overflow-hidden");
    }
    return () => {
      document.body.classList.remove("overflow-hidden");
    };
  }, [open]);

  const [modalOpens, setModalOpens] = useState(false);

  const handleCloseModal = () => {
    setModalOpens(false);
  };
  useEffect(() => {
      const curentVal = findIndex(allUserSubmissions, e => get(selectedUser, "id") == get(e, "user.id"))
        if (is_mobile_menu && allUserSubmissions) {
            const k = allUserSubmissions[curentVal]
            if (k) {
                setData(k);
                setSelectedUser(prev => {
                    const data = { ...prev }
                    data.isPreview = true;
                    return data;
                })
                setSelectedUserChange(prev => {
                    const data = { ...prev }
                    data.isPreview = true;
                    return data;
                })
            }
        }
    }, [is_mobile_menu, allUserSubmissions, setData])
  
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

  const handleRefresh = async () => {
    if (!currentClass?.id) {
      showAlert("No class selected", "error");
      return;
    }
    try {
      setRefreshLoading(true);
      const assignmentId = get(submissionData, "assignmentId") || get(data, "assignmentId");
      const selectedId =
        get(selectedUser, "id") ||
        get(submissionData, "user.id") ||
        get(data, "user.id");
      if (assignmentId) {
        const refreshedSubmissions = await dispatch(
          handleListSubmissionsByAssignmentAndClass(assignmentId, currentClass.id)
        );
        if (!Array.isArray(refreshedSubmissions)) {
          showAlert("Failed to refresh submissions", "error");
          return;
        }
        const enrichedForAssignment = map(refreshedSubmissions, (s) => enrichSubmissionWithAssignment(s));
        const replaceWithFresh = (list) => {
          if (!list?.length) {
            return list;
          }
          return list.map((row) => {
            const uid = get(row, "user.id") || get(row, "userId");
            const fresh = find(
              enrichedForAssignment,
              (s) => get(s, "user.id") === uid || get(s, "userId") === uid
            );
            return fresh || row;
          });
        };
        setAllFilteredUser((prev) => {
          const base = prev?.length ? prev : usersSubmissionData;
          return putSelectedUserAtTop(replaceWithFresh(base), selectedId);
        });
        setAllUserSubmissions((prev) => {
          const base = prev?.length ? prev : usersSubmissionData;
          return putSelectedUserAtTop(replaceWithFresh(base), selectedId);
        });
        const freshSelected = find(
          enrichedForAssignment,
          (s) => get(s, "user.id") === selectedId || get(s, "userId") === selectedId
        );
        if (freshSelected) {
          setData(freshSelected);
        }
      }
      showAlert("Submissions refreshed successfully", "success");
    } catch (error) {
      showAlert("Failed to refresh submissions", "error");
    } finally {
      setRefreshLoading(false);
    }
  }
 
    return (
        <SentryWrap>
            <Wrapper onSubmit={e => e.preventDefault()}>
<div style={{ position: 'absolute', left: '-9999px', top: 0, width: '210mm' }}>
  <AssignmentPrintView
    ref={pdfContentRef}
    questions={pdfData.pdfQuestions}
    answers={pdfData.pdfAnswers}
    studentName={pdfData.pdfStudentName}
    classDisplayName={pdfData.pdfClassName}
    activityTitle={pdfData.pdfActivityTitle}
    overallGrade={pdfData.pdfOverallGrade}
    proficiencyLevel={pdfData.pdfProficiencyLevel}
    aiGrades={pdfData.pdfAiGrades}
    aiFeedbacks={pdfData.pdfAiFeedbacks}
    aiSuggestions={pdfData.pdfAiSuggestions}
  />
</div>
<SpinLoader dataloader={loadingQuestions} />
          <AlertSakeBar
            open={alertSakeBar?.open}
            message={alertSakeBar?.message}
            severity={alertSakeBar?.severity}
            onClose={() => setAlertSakeBar({ open: false, message: "" })}
          />
        <AssignmentImgModal className="max-w-581px" modalOpen={modalOpen} setModalOpen={setModalOpen} page_src={page_src} title={is_soy_story ? getDisplayName(submissionData)  : ""} description={getBookDisplayName(booksAllList, (get(submissionData, "chapter") || get(submissionData, "assignment.chapter")), true, videos, resources)} />
        <StudentAssignmentTrackingModal
            open={Boolean(trackingLogId)}
            onClose={closeStudentTrackingModal}
            logId={trackingLogId || ''}
            attemptLabel={trackingSubmissionLabel}
            submissionId={submissionData?.id}
            allLogSources={trackingLogSources}
        />
  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
    <Header className={`${is_mobile_menu ? "tab-mobile-header-text" : ""} assignmentHeader`}>
    Assignment Review
    <Button 
      variant="contained" 
      color="primary" 
      onClick={handleRefresh}
      disabled={refreshLoading || !currentClass?.id}
      style={{ 
        fontSize: '12px',
        padding: '4px 12px',
        minWidth: 'auto',
        height: '28px'
      }}
    >
      {refreshLoading ? <Loading size={16} white /> : "Refresh"}
    </Button>
  </Header>
     <AiGradeAllButton
        eligibleSubmissions={getEligibleSubmissions}
        assignment={assignment}
        setAlertSakeBar={setAlertSakeBar}
      />
    </div>
  
  {/* {!is_mobile_menu &&  <ShowAndHideRubric />} */}
   

{!is_mobile_menu ? (
    <SplitPane
      split="vertical"
      sizes={sizes}
      onChange={handlePaneResize}
    //   className="customSplitPane"
    className={isIOS ? "customIosMobAndTab" : "customSplitPane"}
      style={{
        display: 'flex',
        height: '110vh',
      }}
      dividerStyle={{
        backgroundColor: '#ccc',
        width: '5px',   
        cursor: 'col-resize',
      }}
      resizerOptions={{
        grabCursor: 'default', // Prevent grab cursor on the entire divider
        dragCursor: 'col-resize', // Only show resize cursor when actually dragging
      }}
    >
      <div style={{ paddingInline: '10px', paddingBottom: "10px", paddingTop:"0px"}}>
        {/* Pane 1 */}
        {panel1()}
      </div>
      <div style={{ paddingInline: '10px', paddingBottom: "10px", paddingTop:"0px"}}>
        {/* Pane 2 */}
        {Panel2()}
        </div>
    </SplitPane>
) : (
    <>
    {is_mobile_menu && (selectedUser?.isPreview ||  selectedUser?.isShowRubric) &&  (
                <div className='flex items-center back-forward-icon AssignmentBackSection'>
                  <BackText  style={{paddingLeft: "6px",marginBottom: "0px"}} onClick={()=>{
                        setSelectedUser(prev => {
                            const data = {...prev};
                             if(prev.isPreview){
                                if(prev.isShowRubric){
                                    setAssignmentshow(false);
                                    data.isShowRubric = false;
                                    return data;
                                }
                                data.isPreview = false;
                            }
                            else if(prev.isShowRubric){
                                data.isShowRubric = false;
                                setAssignmentshow(false);
                            }

                            return data;
                        });
                    }} > <LeftOutlined />
                                    <div>Back To Student List</div>
    
                    </BackText>
                </div>
            )}
    {selectedUser?.isPreview ? (
        <div>
        {!assignmentshow ||(selectedUser?.isShowRubric&& !assignmentRubrics) ? (
                   <>

                    {panel1()}
                   </>
                ) : 

                (
                    <>
                    <UserAddignmentLabel>
                {is_mobile_menu && (
                <div  onClick={() => {
                    setModalOpen(true)
                }}>
                {PosterIg}
                </div>
                )}
               
            
                <div className='selected-user-class flex-wrap gap-4px'>
                    <div className='flex items-center'>
                    <strong className='ml-4px' style={{marginRight: "4px"}}>Student:</strong>{" "}
                  <span>
                    {SelectedUserDropDown()}
                  </span>
                    </div>
                  <div className="flex items-center">
                  | {" "}<strong style={{ marginLeft: "3px", marginRight: "6px" }}>
                    Status:{" "}
                  </strong>{" "}
                  {getStatus(submissionData)}
                  |{" "}<strong style={{ marginLeft: "3px", marginRight: "6px" }}>
                    Due on:{" "}
                  </strong>{" "}
                  {getAssignmentDueOn(submissionData)}
                  </div>
                 
                </div>
            
            </UserAddignmentLabel>


            {assignmentRubrics?<GradebookRubrics
                  assignmentRubrics={assignmentRubrics}
                  currentSubmissionRubric={currentSubmissionRubric}
                  loading={loading == "u"}
                  handleRubricUpdate={handleRubricUpdate}
                  type={"assignmentReviewSubmission"}
                  isMobileMenu={is_mobile_menu}
                  ai_grade_feedback={ai_grade_feedback}
                />:null}
                    </>
                )
               
                }
</div>
    ) : (
        <>
        {!assignmentshow ? (
            <>{UserSelectList()}</>
        ) : 
        (
            <>
            <UserAddignmentLabel>
                {is_mobile_menu && (
                <div  onClick={() => {
                    setModalOpen(true)
                }}>
                {PosterIg}
                </div>
                )}
               
            
                <div className='selected-user-class flex-wrap gap-4px'>
                    <div className='flex items-center'>
                    <strong className='ml-4px'>Student:</strong>{" "}
                  <div className='flex items-center'>
                    <span>
                        {SelectedUserDropDown()}
                    </span>
                  </div>
                    </div>
                  

                  <div  className='flex items-center'>
                    <strong style={{ marginLeft: "3px", marginRight:"3px"}}>
                    | {" "} | Status:{" "}
                    </strong>{" "}
                    {getStatus(submissionData)}
                  </div>
                  
                  
                </div>
            
            </UserAddignmentLabel>

       {!assignmentRubrics?<GradebookRubrics
            assignmentRubrics={assignmentRubrics}
            currentSubmissionRubric={currentSubmissionRubric}
            loading={loading == "u"}
            handleRubricUpdate={handleRubricUpdate}
            type={"assignmentReviewSubmission"}
            isMobileMenu={is_mobile_menu}
            ai_grade_feedback={ai_grade_feedback}
            />:null}
            </>
        )
        
        }
        </>
       
    )
    }
       <div style={{position: "relative"}} className='audio-recorder-grade-assignment-div'>
        {MobileNavSubmission()}
        
       </div>

    </>
)}

</Wrapper>
        </SentryWrap>
    );
};


const MemoizedAssignmentReview = React.memo(AssignmentReview, (prevProps, nextProps) => {
    return (
        prevProps.open === nextProps.open &&
        prevProps.scale_1_5 === nextProps.scale_1_5 &&
        prevProps.gradebook_a_f === nextProps.gradebook_a_f &&
        prevProps.data === nextProps.data &&
        prevProps.usersSubmissionData === nextProps.usersSubmissionData &&
        prevProps.currentClass?.id === nextProps.currentClass?.id &&
        prevProps.returnedSubmissionIds === nextProps.returnedSubmissionIds
    );
});

export default MemoizedAssignmentReview;